/* global $, SGAction, SGEvent, debugConsole, activeComponents */
import DebugConsole from '../debug/debug-console';
import SGLink from '../shopgate-link';

const debugConsole = new DebugConsole();

/*
 * debugConsole was originally window scoped,
 * Don't know if it's not used somewhere in tracking scripts, it's safer to leave it
 * global.
 */
window.debugConsole = debugConsole;

$.shopgate = $.shopgate || {};

var SGProductDetailsCore = function (activeComponents) {
  'use strict';

  var _this = this;
  var productSelectionModes = {
    DEFAULT: 1,
    STEP_BY_STEP_SELECTION_MODE: 2,
    INCOMPLETE_PRODUCTS_WITH_TWO_ATTRIBUTES: 3
  };
  var productSelectionStates = {
    STATE_STEPBYSTEP_SELECTION_DONE: 'sbs_selection_done',
    STATE_STEPBYSTEP_UI_READY: 'sbs_ui_ready'
  };
  var defaults = {
    shopNumber: null,
    shopGroup: null,
    urlDownloadChildProduct: '',
    urlAddToCart: '',
    urlCart: '',
    removeHTMLEntitiesFromProductDescription: true,
    emptyProductAttributeKeyPlaceholder: '&zwnj;',
    allowProductSuggestions: false,
    productAttributeSelectionMode: productSelectionModes.DEFAULT,
    // If set to TRUE, the core will only send parent product data to the plugins,
    // while the attribute selection isn't complete yet.
    showParentProductBeforeStepByStepIsDone: true,
    showDisturberOnAdditionalProductExtensionAmounts: false,
    guid: null,
    ui: {},
    isApp: false,
    plugins: {}
  };
  var options = {};
  var productsComplete = null;
  var products = null;
  var coreInitialized = false;
  // Sometimes core it not yet initialized, but plugins can operate
  var pluginsInitialized = false;
  var documentReady = false;
  var performProductAttributeValidation = true;
  var acceptableFieldCounterVariation = 8;
  var coreStates = [
    'productUpdatePending',
    'stockUpdatePending',
    'priceUpdatePending',
    'cartButtonLocked',
    'cartButtonBusy'
  ];
  var preservedProductFields = [
    'stock_quantity',
    'stock_text',
    'is_not_orderable',
    'amount_info_text',
    'available_text',
    'ignore_stock',
    'quantity_in_cart',
    // Keep attributes because they are trimmed on initialization
    'attribute_1',
    'attribute_2',
    'attribute_3',
    'attribute_4',
    'attribute_5',
    'attribute_6',
    'attribute_7',
    'attribute_8',
    'attribute_9',
    'attribute_10'
  ];
  var states = {};
  var selectedValues = {};
  var dataCache = {};
  var plugins = {
    sort: {
      attributes: [],
      inputs: [],
      options: [],
      option_values: []
    },
    products: {
      data: [],
      ui: []
    }
  };
  var priceHelper = null;
  var orderable = false;
  var shopSettings = window.shopSettings;

  // constants
  _this.DISPLAY_TYPE_DEFAULT = 0;
  _this.DISPLAY_TYPE_SIMPLE = 1;
  _this.DISPLAY_TYPE_SELECT = 2;
  _this.DISPLAY_TYPE_LIST = 3;

  _this.COMPONENT_NAME_STEP_BY_STEP = 'step_by_step_selection';

  // check that the document is ready for DOM manipulation
  contentLoaded(window, function () {
    documentReady = true;
  });

  /**
   * Public getter for product selection modes constants
   * @returns {{DEFAULT: number, STEP_BY_STEP_SELECTION_MODE: number}}
   */
  var getProductSelectionsModes = function () {

    return productSelectionModes;
  };


  /**
   * Public getter for product selection states constants
   * @returns {{STATE_STEPBYSTEP_SELECTION_DONE: number, STATE_STEPBYSTEP_UI_READY: number}}
   */
  var getProductSelectionStates = function () {

    return productSelectionStates;
  };

  /**
   * Updates the product data and the core script options
   * @param {Object} updatedProducts The updated products
   * @param {Object} [updatedOptions] The updated options
   * @returns {void}
   */
  _this.updateProducts = function (updatedProducts, updatedOptions) {
    var localUpdatedOptions;

    // prepare the options for the update
    if (typeof updatedOptions !== 'undefined') {
      localUpdatedOptions = $.extend(clone(options), updatedOptions);
    } else {
      localUpdatedOptions = clone(options);
    }

    productsComplete.product_data = updatedProducts;
    _this.init(localUpdatedOptions, productsComplete);
  };

  /**
   * Inits the ProductDetailsCore
   * @param  {Object} initOptions  Custom options for the core
   * @param  {Object} initProducts The products that shall be processed by the core
   * @return {Boolean}             TRUE on success. FALSE on failure
   */
  _this.init = function (initOptions, initProducts) {
    coreInitialized = false;
    pluginsInitialized = false;
    if (typeof initProducts == 'undefined' && typeof initOptions == 'object') {
      initProducts = initOptions;
    }

    if (typeof initProducts == 'undefined') {
      debugConsole.error('No valid products passed');
      return false;
    }

    // merge the inital options with the defaults and the user defined options
    $.extend(true, options, defaults, initOptions);

    timedDebugGroupStart('coreInitialization', true);

    // init the products variables
    productsComplete = initProducts;
    products = productsComplete.product_data;

    // We need to have clean data before anything else happens,
    // so we check for correct number of attributes before any plugin
    // is notified or any other operation is done
    if (products.children && !analyzeProductAttributes(performProductAttributeValidation)) {
      if (dataCache.attributes.counters) {
        var parentProductId = _this.getParentProductId();
        var attributeNumberError = false;

        for (var childProductId in dataCache.attributes.counters.children) {
          if (
            dataCache.attributes.counters.children[childProductId]
            && (
              dataCache.attributes.counters.children[childProductId].values
              !== dataCache.attributes.counters.parent[parentProductId].values
            )
          ) {
            debugConsole.error('init: Child product %s with invalid number of attributes removed from data', childProductId);

            delete products.children[childProductId];
            delete dataCache.attributes.counters.children[childProductId];

            attributeNumberError = true;
          }
        }

        if (attributeNumberError) {
          // overwrite current_product with parent so that the function getPreselectedChildProduct
          // won't return a wrong/deleted child product
          productsComplete.current_product.product = products.parent.product;
        }
      }
    }

    _this.products = products;
    _this.options = options;

    // try to load selectedValues from history. not for the apps since pushState doesn't really work,
    // because it replaces the URL and the app doesn't use real urls within the address bar.
    if (!options.isApp && history.state && history.state.selectedValues) {
      selectedValues = history.state.selectedValues;
    }


    resetVariables();

    if (typeof products.parent != 'undefined') {
      if (productHasChildProducts(products.parent)) {
        if (!products.children || products.children.length === 0) {
          debugConsole.error('init: Parent product but no children available');
        } else {
          debugConsole.info('init: Parent product with %s children', Object.keys(products.children).length);
        }
      } else {
        debugConsole.info('init: Default product');
      }
    } else {
      debugConsole.error('init: No product data available');
      return false;
    }

    // initialize the ShopgatePrice class with a reference amount form the current selected product
    if (typeof ShopgatePriceHelper == 'function') {
      var parentProduct = getParentProduct(),
        referencePrice = isProduct(parentProduct) && parentProduct.product.price_info && parentProduct.product.price_info.unit_amount_display_formatted ? parentProduct.product.price_info.unit_amount_display_formatted : null;

      priceHelper = new ShopgatePriceHelper(referencePrice ? referencePrice : null);
    } else {
      priceHelper = null;
      console.warn('Class ShopgatePriceHelper not found');
    }


    // initialize the plugins
    _this.callPlugins('onCoreInit', {
      coreOptions: options,
      products: products
    });
    pluginsInitialized = true;
    // select the data strategy
    if (!productHasChildProducts(products.parent)) {


      initDefaultProduct();
      updateCartProductQuantity(selectedValues.quantity);
    } else if (products.parent.product.display_type == _this.DISPLAY_TYPE_LIST) {

      initDefaultProduct();
      if (selectedValues.hasOwnProperty('children')) {
        for (var childId in selectedValues.children) {
          var child = selectedValues.children[childId];
          updateCartProductQuantity(child.quantity, childId);
        }
      }
    } else {
      initProductWithChildren();
      updateCartProductQuantity(selectedValues.quantity);
    }

    coreInitialized = true;

    timedDebugGroupStop('coreInitialization', true);

    return true;

    /**
     * Initialize the data for a default product and call the UI
     */
    function initDefaultProduct() {
      // update the productId
      setProductId(getParentProductId());

      // build the information about the default product for the UI
      var parentProductUpdateResult = {
        product: prepareProductForUI(getParentProduct()),
        product_attributes: null,
        product_options: null,
        product_input_fields: null,
        is_parent_product: true,
        parent_product_id: getParentProductId(),
        product_price_info: calculatePriceInfo(),
      };

      // only provide inputs and options if the product is really a simple product (step by step)
      if (!parentProductHasChildProducts()) {
        parentProductUpdateResult.product_options = createProductOptions(getParentProduct());
        parentProductUpdateResult.product_input_fields =
          createProductInputFields(getParentProduct());
      }

      checkProductProperties(getParentProduct());

      // send the collected data and information to the UI
      updateStates();

      $(document).trigger('shopgateFramework.dataUpdate.product', {
        product: parentProductUpdateResult.product,
        product_price_info: calculatePriceInfo(true),
      });

      triggerOnUpdateProductEvent(parentProductUpdateResult);
    }

    /**
     * Initialize the data for a product with child products and call the UI
     */
    function initProductWithChildren() {
      // prepare some data for working with productAttributes
      initializeProductAttributes();
      checkAttributesSelectableStatus();

      sanitizeProductData('product', getParentProduct(), true);

      // select one of the childProducts (if there was one selected before use this)
      var selectedChildProductId = selectedValues.product_id ? selectedValues.product_id : getPreselectedChildProduct().id;

      if (isStepByStepMode() && selectedChildProductId == getParentProductId()) {
        initDefaultProduct();
      } else {
        selectChildProduct(selectedChildProductId, initSuccessCallback);
      }

      /**
       * The callback that is fired when the UI data is completely prepared by the core
       * @param  {Object} callbackData The data for the UI
       */
      function initSuccessCallback(callbackData) {
        // send the collected data and informations to the UI
        updateStates();

        triggerOnUpdateProductEvent(callbackData);
      }
    }
  };

  /**
   * Takes care about triggering the onUpdateProduct event for the plugins.
   * If the "showParentProductBeforeStepByStepIsDone" option is set, and the the "step by step"
   * mode is active for the current displayed product, the plugins will receive parent product
   * data, till the user made a selection at all attributes.
   * @param {Object} originalPayload The data that the caller supposed send to the plugins
   * @returns {void}
   */
  function triggerOnUpdateProductEvent(originalPayload) {
    let payload = originalPayload;

    if (options.showParentProductBeforeStepByStepIsDone) {
      const stepByStepActive = _this.isStepByStepMode();
      const stepByStepSelectionDone = _this.getState(
        getProductSelectionStates().STATE_STEPBYSTEP_SELECTION_DONE
      );

      if (stepByStepActive && _this.parentProductHasChildProducts() && !stepByStepSelectionDone) {
        const parent = _this.getParentProduct();
        _this.setProductId(parent.product.id);

        payload = {
          ...payload,
          product: parent,
          product_price_info: calculateSBSPriceInfoBasedOnParent(),
          is_parent_product: true,
          product_attributes: null,
          product_input_fields: null,
          product_options: null,
        };
      }
    }

    _this.callPlugins('onUpdateProduct', payload);
  }

  /**
   * Selects a child product and prepares some data for the UI
   * @param  {string|number} childProductId The ID of a child product
   * @param  {Function} successCallback A callback that is called
   *   if we have complete data for the requested child product
   * @returns {void}
   */
  function selectChildProduct(childProductId, successCallback) {
    if (coreInitialized) {
      timedDebugGroupStart('selectChildProduct', true);
    }

    var selectedChildProduct = null;
    var productId = parseInt(childProductId, 10);

    /**
     * Finds a child product in the product list based on the passed parameters
     * @param  {number|null} searchedProductId The ID of a child product that shall be searched
     * @param  {boolean} [ignoreOrderableStatus] If set to TRUE the orderable status
     *   will ignored on child selection
     * @return {Object|null} The found product or NULL if no product could be determined
     */
    function findChildProduct(searchedProductId, ignoreOrderableStatus) {
      var foundChildProduct = null;

      for (var currentChildProductId in products.children) {
        if (products.children.hasOwnProperty(currentChildProductId)) {
          var childProduct = products.children[currentChildProductId];
          var childProductIdInt = parseInt(childProduct.product.id, 10);

          if (searchedProductId && childProductIdInt === searchedProductId) {
            // product by product id
            foundChildProduct = childProduct;
            break;
          } else if (!searchedProductId && productCanBeAddedToCart(childProduct)) {
            // first orderable product
            foundChildProduct = childProduct;
            break;
          } else if (!searchedProductId && ignoreOrderableStatus) {
            // first found product
            foundChildProduct = childProduct;
            break;
          }
        }
      }

      return foundChildProduct;
    }

    /**
     * Prepares the data for an UI update and calls the success callback
     * @param  {Object} childProduct The child product that was selected or downloaded
     * @returns {void}
     */
    function fireSuccessCallback(childProduct) {
      var callbackData = {
        product: prepareProductForUI(childProduct),
        product_attributes: createProductAttributes(childProduct, true),
        product_options: createProductOptions(childProduct),
        product_input_fields: createProductInputFields(childProduct),
        is_parent_product: isParentProduct(childProduct),
        parent_product_id: getParentProductId(),
        product_price_info: calculatePriceInfo(),
      };

      checkProductProperties(childProduct);

      $(document).trigger('shopgateFramework.dataUpdate.product', {
        product: callbackData.product,
        product_price_info: calculatePriceInfo(true),
      });

      if (typeof successCallback === 'function') {
        successCallback(callbackData);
      }
    }

    /**
     * This callback is fired when updated child product data has arrived from the server
     * @param  {Object} downloadedChildProduct The completed child product
     * @returns {void}
     */
    function downloadSuccessCallback(downloadedChildProduct) {
      fireSuccessCallback(downloadedChildProduct);
    }

    if (isStepByStepMode() && productId === getParentProductId()) {
      selectedChildProduct = getParentProduct();
    }

    // a specific child product was requested. so we search for it
    if (!selectedChildProduct && productId) {
      selectedChildProduct = findChildProduct(productId, true);
    }

    // no valid child product was found. so we take the first orderable
    if (!selectedChildProduct) {
      selectedChildProduct = findChildProduct(null);
    }

    // there are no orderable child products. so we take the first
    if (!selectedChildProduct) {
      selectedChildProduct = findChildProduct(null, true);
    }

    // update the productId
    setProductId(selectedChildProduct.product.id);

    if (!coreInitialized) {
      // prepare some data for working with childProducts
      checkProductFields();
    }

    // check the input fields of the selected childProduct
    // to decide if we have to load some data from the server
    var fieldCheckResult = checkProductFieldsForChildProduct(selectedChildProduct);

    // if the selected product has a complete set of fields we can directly inform the UI to update.
    // If not we first have to load some data from the server
    if (fieldCheckResult || isStepByStepMode() && productId === getParentProductId()) {
      fireSuccessCallback(selectedChildProduct);
    } else {
      downloadChildProductData(selectedChildProduct, downloadSuccessCallback);
    }

    if (coreInitialized) {
      timedDebugGroupStop('selectChildProduct');
    }
  }

  /**
   * Requests a complete child product from the server based on the data of an incomplete child product
   * @param  {Object} incompleteChildProduct  The requested incomplete child product
   * @param  {Function} downloadSuccessCallback A callback that is fired when the updated child product data has arrived from the server
   */
  function downloadChildProductData(incompleteChildProduct, downloadSuccessCallback) {
    if (!isChildProduct(incompleteChildProduct)) {
      debugConsole.warn('downloadChildProductData: no child product passed!');
      return false;
    }

    if (typeof downloadSuccessCallback != 'function') {
      downloadSuccessCallback = function (downloadedChildProduct) {};
    }

    performAjaxRequest({
      url: options.urlDownloadChildProduct + '/' + $.sgHelpers.bin2hex(incompleteChildProduct.product.product_number),
      beforeSend: beforeDownloadData,
      complete: completeDownloadData,
      success: successDownloadData
    });

    function beforeDownloadData(jqXHR, settings) {
      timedDebugGroupStart('childProductDataDownload');
      debugConsole.info('Downloading data for productNumber "%s"', incompleteChildProduct.product.product_number);
      setStateProductUpdatePending();
    }

    function completeDownloadData(jqXHR, textStatus) {
      setStateProductUpdatePending(false);
    }

    function errorDownloadData(jqXHR, textStatus, errorThrown) {
      //	timedDebugGroupStop('childProductDataDownload');
    }

    function successDownloadData(response, textStatus, jqXHR) {
      timedDebugGroupStop('childProductDataDownload');

      if (isChildProduct(response.data.product_data)) {
        for (var preservedProductFieldsIndex = 0; preservedProductFieldsIndex < preservedProductFields.length; preservedProductFieldsIndex++) {
          var preservedProductField = preservedProductFields[preservedProductFieldsIndex];

          // copy some of the old product data to the updated product
          if (response.data.product_data.product &&
            products.children[incompleteChildProduct.product.id].product &&
            products.children[incompleteChildProduct.product.id].product.hasOwnProperty(preservedProductField)) {
            response.data.product_data.product[preservedProductField] = products.children[incompleteChildProduct.product.id].product[preservedProductField];
          }
        }

        // overwrite the old product with the new data
        products.children[incompleteChildProduct.product.id] = response.data.product_data;

        downloadSuccessCallback(products.children[incompleteChildProduct.product.id]);
      }
    }
  }

  /**
   * Checks the properties of the selected product and prepare states for the UI
   * @param  {Object} product The product we want to check
   * @return {Object} The modified product
   */
  function checkProductProperties(product) {

    // wait until stock check is done to prevent double disabled cart button
    if (states.stateTypes.stockUpdatePending) {
      return false;
    }

    orderable = checkOrderableStatus(product);

    // for grouped products check if at least one child is selected
    if (product.product.display_type == _this.DISPLAY_TYPE_LIST && !shopSettings.productDisplayListWithCta) {
      if (!selectedValues.hasOwnProperty('children')) {
        orderable = false;
      } else {
        var numSelectedChildren = Object.keys(selectedValues.children).length;
        orderable = numSelectedChildren > 0;
      }
    }

    checkProductInputFieldRequiredStatus();
  }

  function checkOrderableStatus(product) {
    orderable = !product.product.is_not_orderable && checkIsActiveStatus(product);
    if (isChildProduct(product)) {
      orderable = orderable && checkIsActiveStatus(getParentProduct());
    }
    return orderable;
  }

  function checkIsActiveStatus(product) {
    return product.product.is_active;
  }

  /**
   * Check if a product is orderable and in stock or stock is ignored
   * @param product
   * @returns {checkOrderableStatus|boolean|b.product.ignore_stock|*}
   */
  function productCanBeAddedToCart(product) {
    return checkOrderableStatus(product) && (product.product.stock_quantity > 0 || product.product.ignore_stock);
  }

  /**
   * Prepares the data of a product for the UI
   * @param {Object} product The product that we want to prepare
   */
  function prepareProductForUI(product) {
    if (!isProduct(product)) {
      return false;
    }

    sanitizeProductData('product', product, true);

    // remove the properties
    if (typeof product.product.properties != 'object') {
      product.product.properties = null;
    } else {
      for (var propertyKey in product.product.properties) {
        // do something with the properties
      }
    }

    // copy some informations from the parent product to the child products if necessary
    if (isChildProduct(product)) {
      var parentProduct = getParentProduct();

      // copy the properties of the parent to the child product if necessary
      if (!product.product.properties && typeof parentProduct.product.properties == 'object') {
        product.product.properties = parentProduct.product.properties;
      }

      // description
      if (!product.product.description) {
        product.product.description = parentProduct.product.description;
        dataCache.product_checks.description_from_parent[product.product.id] = true;
      }

      // images
      if (!product.product.has_image && parentProduct.product.has_image) {
        product.product.image_urls = parentProduct.product.image_urls;
        product.product.has_image = true;
        product.product.image_count = parentProduct.product.image_urls.length;
      }

      if (!parentProduct.product.is_active) {
        product.product.available_text = parentProduct.product.available_text;
      }
    }

    if (product.product.has_image && !Array.isArray(product.product.image_urls)) {
      product.product.image_urls = [];
    }

    product.product.update_image_gallery = checkGalleryUpdateNecessary(getProductByProductId(dataCache.previous_product_id), product);

    sanitizeProductDescription(product);

    return product;

    /**
     * Checks if the previous and the next product have an identical set of images
     * @param  {Object} previousProduct The previous selected product
     * @param  {Object} nextProduct     The next selected product
     * @return {Boolean}                FALSE if the image sets are identical. TRUE if not
     */
    function checkGalleryUpdateNecessary(previousProduct, nextProduct) {
      if (isProduct(previousProduct) && isProduct(nextProduct)) {
        // both products have the same number of images
        if (Array.isArray(previousProduct.product.image_urls) && Array.isArray(nextProduct.product.image_urls) &&
          previousProduct.product.image_urls.length == nextProduct.product.image_urls.length) {
          // check if image_urls are the same (order is important)
          return JSON.stringify(previousProduct.product.image_urls) !== JSON.stringify(nextProduct.product.image_urls);
        }
      }
      return true;
    }

    /**
     * Try to correct bad html markup by inserting the description into a DOM element that isn't very complex.
     * Lets hope that the browser will correct not well-formed markup.
     * @param  {Object} product A product
     */
    function sanitizeProductDescription(product) {
      // first we sanitize the parent product description
      if (isChildProduct(product) && !dataCache.product_checks.descriptions_sanitized[getParentProductId()]) {
        sanitizeProductDescription(getParentProduct());
      }

      // check if the product description has been sanitized before or was copied from the parent product
      if (product.product.description &&
        !dataCache.product_checks.descriptions_sanitized[product.product.id] &&
        !dataCache.product_checks.description_from_parent[product.product.id]) {

        // lets try to remove html entities from the description if we find a function for that
        if (options.removeHTMLEntitiesFromProductDescription &&
          typeof $.shopgate !== 'undefined' &&
          typeof $.shopgate.decodeHTMLEntities == 'function') {

          try {
            var descriptionLength = product.product.description.length;
            product.product.description = $.shopgate.decodeHTMLEntities(product.product.description);
            if (descriptionLength != product.product.description.length) {
              console.info('sanitizeProductDescription: entities removed from description of product #%s', product.product.id);
            }
          } catch (e) {}
        }

        var e = document.createElement('div');
        e.innerHTML = product.product.description;
        product.product.description = e.innerHTML;

        dataCache.product_checks.descriptions_sanitized[product.product.id] = true;
      }
    }
  }

  /**
   * Creates a price info object which is based on the price info of the parent product. This is
   * used when the "showParentProductBeforeStepByStepIsDone" mode is active, and only parent
   * product information shall be shown while the attribute selection isn't complete yet.
   * @returns {Object} The price info object
   */
  function calculateSBSPriceInfoBasedOnParent() {
    const parent = getParentProduct();
    const parentPriceInfo = { ...parent.product.price_info };

    let lowestPrice = parentPriceInfo.unit_amount_display;
    let lowestPriceFormatted = parentPriceInfo.unit_amount_display_formatted;

    // Unfortunately there is no minimum unit amount for gross prices. But it shouldn't cause a big
    // problem, since this property would only be necessary for shops with the "net and gross"
    // price display mode. By keeping the value at NULL, no gross price will be visible till all
    // attributes have a selection. The price with the big letters is the net price for these shops
    const lowestPriceFormattedGross = null;

    // If the parent product contains min prices, they are considered
    if (parentPriceInfo.unit_amount_display_min) {
      lowestPrice = parentPriceInfo.unit_amount_display_min;
    }

    if (parentPriceInfo.unit_amount_display_min_formatted) {
      lowestPriceFormatted = parentPriceInfo.unit_amount_display_min_formatted;
    }

    let highestPrice = null;

    if (parent.product.unit_amount_display_max) {
      highestPrice = parent.product.unit_amount_display_max;
    }

    parentPriceInfo.lowest_sibling_price = parseFloat(lowestPrice);
    parentPriceInfo.lowest_sibling_price_formatted = lowestPriceFormatted;
    parentPriceInfo.lowest_sibling_price_formatted_gross = lowestPriceFormattedGross;

    parentPriceInfo.highest_sibling_price = parseFloat(highestPrice) || null;

    return parentPriceInfo;
  }

  /**
   * Extends a price info object with properties that are used when the "step by step" product
   * selection mode is active, and the attribute selection isn't complete yet. These exteded
   * properties will be created out of data that is available within a product that is passed
   * within the function parameters.
   * @param {Object} priceInfo The original price info object
   * @param {Object} product The product
   * @returns {Object} The extended price info object
   */
  function extendSBSPriceInfoBasedOnProduct(priceInfo, product) {
    const extendedPriceInfo = { ...priceInfo };

    let compareAtts = true;

    if (
      typeof dataCache.attributes === 'undefined' ||
      typeof dataCache.attributes.lastChosenAttribute === 'undefined' ||
      !dataCache.attributes.lastChosenAttribute
    ) {
      compareAtts = false;
    }

    let lowestSiblingPrice = extendedPriceInfo.unit_amount_display;
    let lowestSiblingPriceFormatted = extendedPriceInfo.unit_amount_display_formatted;
    let lowestSiblingPriceFormattedGross = null;
    let highestSiblingPrice = extendedPriceInfo.unit_amount_display;

    // No need for this now, but If you need, just uncomment this and one below
    // var highestSiblingPriceFormatted = clonedPriceInfo.unit_amount_display_formatted;
    let matchedChild;
    const parentProductCanBeAddedToCart = productCanBeAddedToCart(getParentProduct());

    for (let childId in _this.products.children) {
      if (childId === product.product.id) {
        continue;
      }

      matchedChild = _this.products.children[childId];

      /**
       * For child products we compare siblings, to get lowest and highest price possible.
       * When parent is preselected, no need to compare atts, but as well as in child products
       * prices of not available products should not be taken into consideration
       * if any other child product is available.
       */
      if (compareAtts) {
        for (let i = 1; i <= dataCache.attributes.lastChosenAttribute; i += 1) {
          let currentAttributeIsOrderable = null;

          if (
            product.product[`attribute_${i}`] !==
            matchedChild.product[`attribute_${i}`]
          ) {
            matchedChild = null;
            break;
          } else if (!productCanBeAddedToCart(matchedChild)) {
            /**
             * This could be done in one check, but isAttributeOrderable is expensive for CPU
             * so it's better to call it only if really required
             */
            if (currentAttributeIsOrderable === null) {
              currentAttributeIsOrderable = isAttributeOrderable(
                i,
                product.product[`attribute_${i}`]
              );
            }

            if (currentAttributeIsOrderable === true) {
              matchedChild = null;
              break;
            }
          }
        }
      } else if (!productCanBeAddedToCart(matchedChild) && parentProductCanBeAddedToCart) {
        matchedChild = null;
      }

      if (matchedChild) {
        const matchedChildPrice = {
          unit_amount_display: 0,
          unit_amount_display_formatted: 0,
          unit_amount_gross: 0,
        };

        if (
          matchedChild.product.has_block_pricing &&
          Array.isArray(matchedChild.product.price_info.block_pricing)
        ) {
          matchedChild.product.price_info.block_pricing.forEach((priceGroup) => {
            if (
              priceGroup.unit_amount_display &&
              priceGroup.unit_amount_display_formatted &&
              (
                !matchedChildPrice.unit_amount_display ||
                parseFloat(priceGroup.unit_amount_display) <
                parseFloat(matchedChildPrice.unit_amount_display)
              )
            ) {
              matchedChildPrice.unit_amount_display = priceGroup
                .unit_amount_display;

              matchedChildPrice.unit_amount_display_formatted = priceGroup
                .unit_amount_display_formatted;

              if (typeof priceGroup.unit_amount_gross !== 'undefined') {
                matchedChildPrice.unit_amount_gross = priceGroup.unit_amount_gross;

                matchedChildPrice.unit_amount_gross_formatted = priceHelper
                  .getAmountFormatted(priceGroup.unit_amount_gross);
              }
            }
          });
        } else {
          matchedChildPrice.unit_amount_display = matchedChild
            .product
            .price_info
            .unit_amount_display;

          matchedChildPrice.unit_amount_display_formatted = matchedChild
            .product
            .price_info
            .unit_amount_display_formatted;

          if (typeof matchedChild.product.price_info.gross !== 'undefined') {
            matchedChildPrice.unit_amount_gross = matchedChild
              .product
              .price_info
              .gross;

            matchedChildPrice.unit_amount_gross_formatted = priceHelper
              .getAmountFormatted(matchedChild.product.price_info.gross);
          }
        }

        if (
          parseFloat(lowestSiblingPrice) >
          parseFloat(matchedChildPrice.unit_amount_display)
        ) {
          lowestSiblingPrice = matchedChildPrice.unit_amount_display;
          lowestSiblingPriceFormatted = matchedChildPrice.unit_amount_display_formatted;

          if (matchedChildPrice.unit_amount_gross_formatted) {
            lowestSiblingPriceFormattedGross = matchedChildPrice.unit_amount_gross_formatted;
          }
        }

        if (highestSiblingPrice < matchedChildPrice.unit_amount_display) {
          highestSiblingPrice = matchedChildPrice.unit_amount_display;
          // highestSiblingPriceFormatted = matchedChildPrice.unit_amount_display_formatted;
        }
      }
    }

    extendedPriceInfo.lowest_sibling_price = parseFloat(lowestSiblingPrice);
    extendedPriceInfo.lowest_sibling_price_formatted = lowestSiblingPriceFormatted;
    extendedPriceInfo.lowest_sibling_price_formatted_gross = lowestSiblingPriceFormattedGross;

    extendedPriceInfo.highest_sibling_price = highestSiblingPrice;

    return extendedPriceInfo;
  }

  /**
   * Creates an updated price info object that regards the additional amounts of
   * the current selected product option values and product input fields
   * @param {boolean} [calcGrossAndNet] If set to TRUE the function will also calculate
   *   gross and net amounts for the default price attributes
   * @param {Object} [product] An explicitly selected product for the price calculation.
   *   By default the "selected product" is used for the calculation. ATTENTION: Due to the basic
   *   system, additional prices for option and inputs cannot be regarded for this product.
   * @returns {Object} The updated price info
   */
  function calculatePriceInfo(calcGrossAndNet, product) {
    var selectedProduct;
    var selectedOptionValues;
    var selectedInputs;

    if (isProduct(product)) {
      selectedProduct = product;
    } else {
      selectedProduct = getSelectedProduct();
      selectedOptionValues = getSelectedProductOptionValues();
      selectedInputs = getSelectedProductInputFields();
    }

    var additionalAmountFromProductOptions = 0;
    var additionalAmountFromProductOptionsNet = 0;
    var additionalAmountFromProductOptionsGross = 0;

    var additionalAmountFromProductInputFields = 0;
    var additionalAmountFromProductInputFieldsNet = 0;
    var additionalAmountFromProductInputFieldsGross = 0;

    var clonedPriceInfo = clone(selectedProduct.product.price_info);
    var quantity;

    if (calcGrossAndNet) {
      var displayAmountNet = parseFloat(selectedProduct.product.unit_amount_net);
      var displayAmountGross = parseFloat(selectedProduct.product.unit_amount_with_tax);

      clonedPriceInfo.unit_amount_display_net = displayAmountNet;
      clonedPriceInfo.unit_amount_display_net_formatted = priceHelper
        .getAmountFormatted(displayAmountNet);

      clonedPriceInfo.unit_amount_display_gross = displayAmountGross;
      clonedPriceInfo.unit_amount_display_gross_formatted = priceHelper
        .getAmountFormatted(displayAmountGross);
    }

    // Calculate block pricing
    if (
      selectedProduct.product.has_block_pricing &&
      Array.isArray(clonedPriceInfo.block_pricing)
    ) {
      quantity = parseInt(selectedProduct.product.quantity_in_cart, 10) +
        parseInt(selectedValues.quantity, 10);

      var blockPricingGroup = getBlockPricingGroupForQuantity(selectedProduct, quantity);
      if (
        blockPricingGroup &&
        blockPricingGroup.hasOwnProperty('unit_amount_display') &&
        blockPricingGroup.hasOwnProperty('unit_amount_display_formatted')
      ) {
        if (
          clonedPriceInfo.unit_amount_display > parseFloat(blockPricingGroup.unit_amount_display)
        ) {
          if (!clonedPriceInfo.strike_price_display) {
            clonedPriceInfo.strike_price_display = clonedPriceInfo.unit_amount_display;
            clonedPriceInfo.strike_price_display_formatted
              = clonedPriceInfo.unit_amount_display_formatted;
          }
          // Overwrite the default prices with the prices of the picked block pricing group
          clonedPriceInfo.unit_amount_display = parseFloat(blockPricingGroup.unit_amount_display);
          clonedPriceInfo.unit_amount_display_formatted = blockPricingGroup
            .unit_amount_display_formatted;

          if (calcGrossAndNet) {
            var blockPriceDisplayAmountNet = parseFloat(blockPricingGroup.unit_amount_net);
            var blockPriceDisplayAmountGross = parseFloat(blockPricingGroup.unit_amount_gross);

            clonedPriceInfo.unit_amount_display_net = blockPriceDisplayAmountNet;
            clonedPriceInfo.unit_amount_display_net_formatted = priceHelper
              .getAmountFormatted(blockPriceDisplayAmountNet);

            clonedPriceInfo.unit_amount_display_gross = blockPriceDisplayAmountGross;
            clonedPriceInfo.unit_amount_display_gross_formatted = priceHelper
              .getAmountFormatted(blockPriceDisplayAmountGross);
          }
        }
      }
    } else if (isChildProduct(selectedProduct)) {
      // TODO: what to do if parent product has block pricing?
    }

    // Get the additional amounts for the current selected product option values
    if (selectedOptionValues) {
      for (var productOptionId in selectedOptionValues) {
        var productOptionValue = selectedOptionValues[productOptionId];

        additionalAmountFromProductOptions +=
          parseFloat(productOptionValue.product_option_value.price_info.additional_amount_display);

        if (calcGrossAndNet) {
          additionalAmountFromProductOptionsNet +=
            parseFloat(productOptionValue.product_option_value.additional_amount_net);

          additionalAmountFromProductOptionsGross +=
            parseFloat(productOptionValue.product_option_value.additional_amount_with_tax);
        }
      }
    }

    // Get the additional amounts for the current selected product input fields
    if (selectedInputs) {
      for (var productInputFieldId in selectedInputs) {
        var productInputField = selectedInputs[productInputFieldId];

        // Only add the additional amount if the input field is filled out
        if (
          productInputField.product_input_field.value ||
          productInputField.product_input_field.is_required
        ) {
          additionalAmountFromProductInputFields +=
            parseFloat(productInputField.product_input_field.price_info.additional_amount_display);

          if (calcGrossAndNet) {
            additionalAmountFromProductInputFieldsNet +=
              parseFloat(productInputField.product_input_field.additional_amount_net);

            additionalAmountFromProductInputFieldsGross +=
              parseFloat(productInputField.product_input_field.additional_amount_with_tax);
          }
        }
      }
    }

    // Calculate the complete additional amount
    var additionalAmountComplete = additionalAmountFromProductOptions +
      additionalAmountFromProductInputFields;

    var additionalAmountCompleteNet = additionalAmountFromProductOptionsNet +
      additionalAmountFromProductInputFieldsNet;

    var additionalAmountCompleteGross = additionalAmountFromProductOptionsGross +
      additionalAmountFromProductInputFieldsGross;
    // Only update the price info if the resulting amounts would change
    if (additionalAmountComplete != 0) {
      // Update the original display price
      var completeDisplayAmount = clonedPriceInfo.unit_amount_display + additionalAmountComplete;

      clonedPriceInfo.unit_amount_display = completeDisplayAmount > 0 ? completeDisplayAmount : 0;
      clonedPriceInfo.unit_amount_display_formatted = priceHelper
        .getAmountFormatted(completeDisplayAmount);

      if (calcGrossAndNet) {
        var completeDisplayAmountNet = parseFloat(selectedProduct.product.unit_amount_net) +
          additionalAmountCompleteNet;

        var completeDisplayAmountGross = parseFloat(selectedProduct.product.unit_amount_with_tax) +
          additionalAmountCompleteGross;

        // Update the price info. Take care that the product prices don't turn negative.
        clonedPriceInfo.unit_amount_display_net = completeDisplayAmountNet > 0 ?
          completeDisplayAmountNet : 0;

        clonedPriceInfo.unit_amount_display_net_formatted = priceHelper
          .getAmountFormatted(completeDisplayAmountNet);

        clonedPriceInfo.unit_amount_display_gross = completeDisplayAmountGross > 0 ?
          completeDisplayAmountGross : 0;

        clonedPriceInfo.unit_amount_display_gross_formatted = priceHelper
          .getAmountFormatted(completeDisplayAmountGross);
      }

      // Update the strike prices if present
      if (clonedPriceInfo.strike_price_display) {
        // Update the original strike price
        var completeStrikePriceDisplayAmount = clonedPriceInfo.strike_price_display +
          additionalAmountComplete;

        clonedPriceInfo.strike_price_display = completeStrikePriceDisplayAmount > 0 ?
          completeStrikePriceDisplayAmount : 0;

        clonedPriceInfo.strike_price_display_formatted = priceHelper
          .getAmountFormatted(clonedPriceInfo.strike_price_display);

        // Update the discount amounts
        clonedPriceInfo.discount_amount = priceHelper
          .subtractAmounts(
            clonedPriceInfo.strike_price_display,
            clonedPriceInfo.unit_amount_display
          );

        clonedPriceInfo.discount_amount_formatted = priceHelper
          .getAmountFormatted(clonedPriceInfo.discount_amount);

        clonedPriceInfo.discount_display_formatted = clonedPriceInfo.discount_amount_formatted;
      }
    }

    // Recalculate the percentage discount if it's not declared as final
    if (clonedPriceInfo.strike_price_display && !clonedPriceInfo.discount_percent_is_final) {
      // Calculate the saved percentage
      const savedPercent = priceHelper
        .calculatePercentSaved(
          clonedPriceInfo.strike_price_display,
          clonedPriceInfo.unit_amount_display,
          true
        );

      clonedPriceInfo.discount_percent = savedPercent;
      clonedPriceInfo.discount_percent_formatted = savedPercent ?
        clonedPriceInfo.discount_percent : '';

      if (clonedPriceInfo.discount_percent) {
        clonedPriceInfo.discount_display_formatted += `(${clonedPriceInfo.discount_percent_formatted})`;
      }
    }
    /**
     * Handling the price interval mode.
     * If in STEP_BY_STEP_MODE and choice is not done and final price can differ
     * (from the current "selected" product), we should show the cheapest price with "from" prefix.
     */
    if (
      parentProductHasChildProducts() &&
      isStepByStepMode() &&
      !_this.getState(_this.getProductSelectionStates().STATE_STEPBYSTEP_SELECTION_DONE)
    ) {
      if (options.showParentProductBeforeStepByStepIsDone) {
        clonedPriceInfo = calculateSBSPriceInfoBasedOnParent();
      } else {
        clonedPriceInfo = extendSBSPriceInfoBasedOnProduct(clonedPriceInfo, selectedProduct);
      }
    }

    return clonedPriceInfo;
  }

  /**
   * Resets some of the global variables. This should be called on init()
   */
  function resetVariables() {
    coreInitialized = false;
    pluginsInitialized = false;
    selectedValues = sanitizeSelectedValues();
    dataCache = {};

    states = {};

    setStateProductUpdatePending(false);
    setStateStockUpdatePending(false);
    setStatePriceUpdatePending(false);
    setStateCartButtonLocked(true);
    setStateCartButtonBusy(false);

    // initialize the dataCache fields
    if (!dataCache.product_checks) {
      dataCache.product_checks = {
        parent: {},
        children: {},
        descriptions_sanitized: {},
        description_from_parent: {}
      };
    }

    dataCache.productSelectionMode = productSelectionModes.DEFAULT;
  }

  /**
   * Updates the selected product id
   * @param {Number} The product id
   */
  function setProductId(value) {
    if (!coreInitialized) {
      dataCache.previous_product_id = null;
    } else if (selectedValues.product_id) {
      dataCache.previous_product_id = parseInt(selectedValues.product_id);
    }

    selectedValues.product_id = parseInt(value);
    saveSelectedValuesinHistory();
  }

  /**
   * Returns the id of the previous selected product
   * @return {Number} A product id or NULL
   */
  function getPreviousProductId() {
    return dataCache.previous_product_id;
  }

  /**
   * Saves selected product (+ some additional data)
   * to history. Also changes the URL.
   *
   * Should do nothing if STEP_BY_STEP_MODE and selection is
   * not done.
   *
   * @returns {*}
   */
  function saveSelectedValuesinHistory() {
    var productNumber = null;
    if (isStepByStepMode() && !_this.getState(_this.getProductSelectionStates().STATE_STEPBYSTEP_SELECTION_DONE)) {
      if (!_this.getState(_this.getProductSelectionStates().STATE_STEPBYSTEP_UI_READY)) {
        return false;
      }
      productNumber = products.parent.product.product_number;
    }

    return replaceHistoryState(productNumber);
  }

  /**
   * Replaces history state using native history.replaceState
   * @todo consider using $.sgHelpers.historyChange for legacy browser support
   *
   * @param productNumber
   * @returns {boolean}
   */
  function replaceHistoryState(productNumber) {
    // replaceState isn't used within the apps because pushState doesn't really work,
    // since it replaces the URL and the app doesn't use real urls within the address bar.
    if (!options.isApp && typeof window.history !== 'undefined' && 'replaceState' in window.history) {
      if (typeof productNumber === 'undefined' || !productNumber) {
        var selectedProduct = getSelectedProduct();
        productNumber = selectedProduct.product.product_number;
      }
      var encodedProductNumber = $.sgHelpers.bin2hex(productNumber);

      history.replaceState({
        selectedValues: selectedValues
      }, null, encodedProductNumber + window.location.search);

      return true;
    } else {
      return false;
    }

  }

  /**
   * Checks if step by step mode is enabled
   * @returns {boolean}
   */
  function isStepByStepMode() {
    if (_this.isComponentActive(_this.COMPONENT_NAME_STEP_BY_STEP) && options.productAttributeSelectionMode === productSelectionModes.STEP_BY_STEP_SELECTION_MODE) {
      return true;
    }

    return false;
  }

  /**
   * Find correct block pricing group for a given quantity
   *
   * @param product
   * @param quantity
   * @returns {*}
   */
  function getBlockPricingGroupForQuantity(product, quantity) {
    var blockPricingGroup = null;

    // Check some requirements
    if (
      product &&
      product.product &&
      product.product.price_info &&
      product.product.price_info.block_pricing &&
      quantity !== 'undefined'
    ) {
      // Go through price groups
      product.product.price_info.block_pricing.some(function (priceGroup) {
        // Return if quantity does not match
        if (
          quantity < priceGroup.min_quantity ||
          (priceGroup.max_quantity !== null && quantity > priceGroup.max_quantity)
        ) {
          return false;
        }

        // Found matching group, exit loop
        blockPricingGroup = priceGroup;
        return true;
      });
    }

    return blockPricingGroup;
  }


  /*********************************************
   * BASIC ACTIONS FOR THE INTERACTION WITH THE UI
   *********************************************/

  /**
   * Prepares product data that will be processed after a successful addToCart request.
   * The data is prepared BEFORE the request, because it uses the currentSelectedProduct and
   * the currentSelectedValues. While a request is running, the user might pick another product,
   * what causes a change of this data. So it's better to perform this step before the request.
   * @returns {{products: Array, display_type: *}}
   */
  function prepareProductAddedToCartData() {
    /**
     * Creates the return data for the prepareProductAddedToCartData function
     * @param {Object} product The product for which the data is created
     * @param {Object} [explicitSelectedValues] An object that represents selected product values
     * @returns {{products: Array, display_type: *}}
     * @private
     */
    function _prepareData(product, explicitSelectedValues) {
      var preparedData = {
        products: [],
        display_type: product.product.display_type
      };

      /**
       * Adds response data for a product to the setResponse result
       * @param {Object} product The product for which we create the data
       * @param {Number} quantity The quantity of the product that was added to the cart
       * @private
       */
      function _addDataForProductToPreparedData(product, quantity) {
        if (!isProduct(product)) {
          return false;
        }

        var productData = {
          quantity: parseInt(quantity, 10),
          product: product.product,
          parent_product_id: getParentProductId(),
          is_parent_product: isParentProduct(product),
          product_attributes: null,
          product_options: null,
          product_input_fields: null
        };

        if (getSelectedProduct().product.display_type != _this.DISPLAY_TYPE_LIST) {
          // Collect the data for normal products (no grouped products)
          productData.product_price_info = calculatePriceInfo(true);
          productData.product_attributes = createProductAttributes(product, true);
          productData.product_options = getProductOptionListForProduct(product);
          productData.product_input_fields = getProductInputFieldListForProduct(product);
        } else {
          // For grouped products the default behavior of the calculatePriceInfo has to be bypassed
          // by passing the product directly to the function. Attributes, options and input fields
          // are not supported by grouped products
          productData.product_price_info = calculatePriceInfo(true, product);
        }

        preparedData.products.push(productData);
      }

      if (
        explicitSelectedValues &&
        explicitSelectedValues.hasOwnProperty('children') &&
        Object.keys(explicitSelectedValues.children).length
      ) {
        // Add multiple products to the prepared data object
        for (var childProductId in explicitSelectedValues.children) {
          var selectedChildValues = explicitSelectedValues.children[childProductId];
          _addDataForProductToPreparedData(
            getProductByProductId(childProductId),
            selectedChildValues.quantity
          );
        }
      } else {
        _addDataForProductToPreparedData(product, selectedValues.quantity);
      }

      return preparedData;
    }

    var selectedProduct = getSelectedProduct();
    var explicitSelectedValues = null;

    if (selectedProduct.product.display_type == _this.DISPLAY_TYPE_LIST) {
      explicitSelectedValues = _this.getSelectedValues(true);
    }

    return _prepareData(selectedProduct, explicitSelectedValues);
  }

  /**
   * Processes the response of an addToCart request
   * @param {Object} response The addToCart response
   * @param {Object} preparedProductData Product data that was created before sending the request
   */
  function processAddedToCartResponse(response, preparedProductData) {
    /**
     * Updates the quantity_in_cart property of a product
     * @param {Object} product The product that shall be modified
     * @param {number} additionalQuantity The additional quantity
     * @private
     */
    function _updateProductQuantityInCart(product, additionalQuantity) {
      if (product && product.product.hasOwnProperty('quantity_in_cart')) {
        var productQuantity = parseInt(product.product.quantity_in_cart, 10);
        product.product.quantity_in_cart = productQuantity + additionalQuantity;
      }
    }

    var cartInfo;

    if (response.hasOwnProperty('data') && response.data.hasOwnProperty('cart')) {
      // Set the cart info if data was delivered within the response
      cartInfo = response.data.cart;
    }

    if (response.hasOwnProperty('success') && response.success) {
      // Add the fresh cart info to the prepared data
      preparedProductData.cart_info = cartInfo;

      // Update the quantity_in_cart properties of the affected products
      preparedProductData.products.forEach(function (preparedProduct) {
        // Get if fresh to avoid side effects from references
        var product = getProductByProductId(preparedProduct.product.id);
        var quantity = preparedProduct.quantity;

        if (product) {
          _updateProductQuantityInCart(product, quantity);

          if (isChildProduct(product)) {
            // In case of child products the quantity_in_cart of the parent product is updated
            _updateProductQuantityInCart(getParentProduct(), quantity);
          }
        }
      });

      // Call the plugins
      _this.callPlugins('onProductAddedToCart', preparedProductData);
    } else {
      $('html, body').animate({ scrollTop: 0 }, 'slow');
    }

    // Reset the view after the response came in
    updateCartProductQuantity(1);
    setStateCartButtonBusy(false);

    if (cartInfo) {
      // Send out the updated cart data
      $(document).trigger('shopgateFramework.dataUpdate.cart', [{
        cart: cartInfo
      }]);
    }
  }

  /**
   * Adds the current selected product to the cart and sends control informations to the UI
   */
  function addProductToCart() {
    var preparedAddedToCartData;

    /**
     * AJAX beforeSend callback
     */
    function beforeAddToCartSend() {
      // Lock the cart button and call the plugins
      setStateCartButtonBusy(true);
      _this.callPlugins('onCartButtonPressed', selectedValues);
    }

    /**
     * AJAX success callback
     * @param {Object} response The request response
     */
    function addToCartSuccess(response) {
      processAddedToCartResponse(response, preparedAddedToCartData);
    }

    // React only if the button isn't locked
    if (!states.stateTypes.cartButtonLocked) {
      preparedAddedToCartData = prepareProductAddedToCartData();

      performAjaxRequest({
        url: options.urlAddToCart,
        data: {
          product_id: selectedValues.product_id,
          selected_values: selectedValues
        },
        beforeSend: beforeAddToCartSend,
        success: addToCartSuccess
      });

      return true;
    } else {
      return false;
    }
  }

  /**
   * Updates the cart product quantity, corrects them if neccesary and sends a confirmation to the UI
   * @param  {Number|String} value the new quantity
   * @param {Number} id of the product where the quantity changed
   * @return {Boolean} TRUE on success
   */
  function updateCartProductQuantity(value, productId) {

    if (productId == null) {
      productId = selectedValues.product_id;
    }

    if (selectedValues.product_id == productId) {
      if (!isInteger(value) || value < 1) {
        value = 1;
      }
      selectedValues.quantity = value;
    } else if (getSelectedProduct().product.display_type == _this.DISPLAY_TYPE_LIST) { // save quantity for child of grouped product
      if (!selectedValues.hasOwnProperty('children')) {
        selectedValues.children = {};
      }
      // if value is smaller zero or product can not be added to cart set quantity to zero
      if (!isInteger(value) || value <= 0 || !products.children.hasOwnProperty(productId) || !productCanBeAddedToCart(products.children[productId])) {
        value = '0';
        delete selectedValues.children[productId];
      } else {
        if (!selectedValues.children.hasOwnProperty(productId)) {
          selectedValues.children[productId] = {};
        }
        selectedValues.children[productId].quantity = value;
      }

      // if no child is selected disable cart-button
      var numSelectedChildren = Object.keys(selectedValues.children).length;
      setStateCartButtonLocked(numSelectedChildren == 0 && !shopSettings.productDisplayListWithCta);

    }

    saveSelectedValuesinHistory();
    updateProductPriceInfo();

    _this.callPlugins('onUpdateCartProductQuantity', {
      productId: productId,
      quantity: value
    });

    return true;
  }

  /**
   * Updates the stock data for the current selected product
   *
   */
  function updateProductStockQuantity() {

    var selectedProduct = getSelectedProduct(),
      data;

    // call this not in case of livestock && grouped products
    checkProductProperties(selectedProduct);

    validateSelectedQuantities();

    // selected product might be changed, so it's need to be checked again before data is passed to callback
    data = getSelectedProduct();

    _this.callPlugins('onUpdateProductStockQuantity', data); // for each child? remove quantity for selected children if not orderable
  }

  /**
   * Check if the selected child(ren) are still valid
   */
  function validateSelectedQuantities() {
    // Remove children of grouped product from selectedValues that are not orderable
    if (products.parent.product.display_type == _this.DISPLAY_TYPE_LIST) {
      // in the apps there is the case that the selectedValues are not set correctly if the update is requested from product_details_app_scripts/livestock plugin
      if (selectedValues.hasOwnProperty('children')) {
        for (var id in selectedValues.children) {
          if (!products.children.hasOwnProperty(id) || !productCanBeAddedToCart(products.children[id])) {
            delete selectedValues.children[id];
            updateCartProductQuantity(0, id);
          }
        }
      }
    } else {
      // If selected child product is not orderable try to switch to another child product
      var selectedProduct = getSelectedProduct();
      if (!productCanBeAddedToCart(selectedProduct)) {
        for (var childProductId in products.children) {
          var childProduct = products.children[childProductId];
          if (productCanBeAddedToCart(childProduct)) {
            // Select orderable product
            selectChildProduct(childProduct.product.id, function (callbackData) {
              // Send the collected data and informations to the UI
              updateStates();
              triggerOnUpdateProductEvent(callbackData);
            });
            break;
          }
        }
      }
    }
  }

  /**
   * Updates the product price info. It regards the extra charges for current selected product options and product input fields
   */
  function updateProductPriceInfo() {
    _this.callPlugins('onUpdateProductPriceInfo', {
      price_info: calculatePriceInfo()
    });
  }

  /*********************************************
   * PRODUCT OPTIONS
   *********************************************/

  /**
   * Updates the selected productOptionValue of a productOption
   * @param {String} productId The ID of the product the updated productOption belongs to
   * @param {String} productOptionId The ID of the productOption the updated productOptionValue belongs to
   * @param {String} productOptionValueId The ID of the updated productOptionValue
   * @param {Array} The updated productOptions
   */
  function updateSelectedProductOptionValue(productId, productOptionId, productOptionValueId) {
    if (!validateSelectedValuesDataForUpdate('options', productId, productOptionId)) {
      return false;
    }

    var productOptionCacheEntry = getProductAndCacheEntryFromCache('options', dataCache.options, productId, productOptionId),
      orderedProductOptionValues = [],
      selectedProductOptionValueIndex = null,
      product = productOptionCacheEntry.product,
      productOption = productOptionCacheEntry.cache_entry;

    // update the selected values
    selectedValues.options[productId][productOptionId] = productOptionValueId;
    saveSelectedValuesinHistory();

    // update the productOptionValue cache
    setProductOptionValue(product, productOption, productOption.product_option.values[productOptionValueId].product_option_value.id);

    hideVisibleProductOptionValuesLists();

    updateProductPriceInfo();

    // return the updated productOptions
    return getProductOptionListForProduct(product);
  }

  /**
   * Creates a list of ordered options for a specific product
   * @param {Object} product The product for which we create the data
   * @param {Array} The ordered list
   */
  function getProductOptionListForProduct(product) {
    if (!productHasOptions(product)) {
      return [];
    }

    var dataCacheRelevant = isChildProduct(product) ? dataCache.options.children[product.product.id] : dataCache.options.parent[product.product.id],
      orderedProductOptions = [];

    // transform the input object to an array that can be sorted
    for (var cachedProductOptionIndex in dataCacheRelevant) {
      var cachedProductOption = dataCacheRelevant[cachedProductOptionIndex],
        clonedProductOption = null,
        selectedProductOptionValue = cachedProductOption.product_option.value_id ? cachedProductOption.product_option.value_id : null,
        orderedProductOptionValues = [];

      // we have to clone the cachedProductOption because in the next lines we change the structure of the cachedProductOptionValues
      clonedProductOption = clone(cachedProductOption);

      // Transform option values to array so it can be sorted
      for (var cachedProductOptionValueIndex in clonedProductOption.product_option.values) {
        var cachedProductOptionValue = clonedProductOption.product_option.values[cachedProductOptionValueIndex];
        orderedProductOptionValues.push(cachedProductOptionValue);
      }

      // Sort the option values
      orderedProductOptionValues = sortProductOptionValues(product, clonedProductOption, orderedProductOptionValues);

      // Loop through sorted values
      for (var productOptionValueIndex = 0; productOptionValueIndex < orderedProductOptionValues.length; productOptionValueIndex++) {
        var productOptionValue = orderedProductOptionValues[productOptionValueIndex];

        if (selectedProductOptionValue && selectedProductOptionValue == productOptionValue.product_option_value.id) {
          clonedProductOption.product_option.value = productOptionValue.product_option_value.name;
          cachedProductOption.product_option.value = productOptionValue.product_option_value.name;
          clonedProductOption.product_option.value_index = productOptionValueIndex;
          cachedProductOption.product_option.value_index = productOptionValueIndex;

          productOptionValue.product_option_value.selected = true;
        } else {
          productOptionValue.product_option_value.selected = false;
        }
      }

      // Save sorted values back to product option
      clonedProductOption.product_option.values = orderedProductOptionValues;

      orderedProductOptions.push(clonedProductOption);
    }

    // sort and return
    return sortProductOptions(product, orderedProductOptions);
  }

  /**
   * Creates a product option value list for a selected product option
   * @param {Number} productId The ID of the product the updated productOption belongs to
   * @param {Number} productOptionId The ID of the product option for which we create the list
   * @return {Boolean} TRUE on success. FALSE on failure.
   */
  function getProductOptionValuesForProductOptionId(productId, productOptionId) {
    var product = getProductByProductId(productId);
    if (isProduct(product)) {
      var dataCacheScoped = dataCache.options,
        dataCacheRelevant = isChildProduct(product) ? dataCacheScoped.children : dataCacheScoped.parent,
        productOptionsList = getProductOptionListForProduct(product),
        productOptionValuesList = null;

      for (var productOptionIndex in productOptionsList) {
        var productOption = productOptionsList[productOptionIndex];
        if (!productOption.hasOwnProperty('product_option')) {
          continue;
        }
        if (productOption.product_option.id == productOptionId) {
          productOptionValuesList = productOption;
          break;
        }
      }

      if (productOptionValuesList) {
        // update the prices of the product option values
        productOptionValuesList = calculatePricesForProductOptionValuesList(productOptionValuesList);

        if (productHasChildProducts(product) || isChildProduct(product)) {
          hideVisibleProductAttributeValuesLists();
        }

        hideVisibleProductOptionValuesLists(productId, productOptionId);

        cacheVisibleProductOptionValuesList(productOptionValuesList);
        _this.callPlugins('onShowProductOptionValuesList', productOptionValuesList);
        return true;
      }
    }

    return false;
  }

  /**
   * Updates the additional prices of all product option values that are assigned to a product option
   * @param {Object} productOption The product option
   * @returns {Object} The updated product option
   */
  function calculatePricesForProductOptionValuesList(productOption) {
    if (isProductOption(productOption) && Array.isArray(productOption.product_option.values) && productOption.product_option.values.length > 0) {
      var selectedProductOptionValue = getSelectedProductOptionValues(productOption.product_option.id);

      if (isProductOptionValue(selectedProductOptionValue) && hasPriceInfo(selectedProductOptionValue)) {
        var selectedProductOptionValuePriceInfo = selectedProductOptionValue.product_option_value.price_info;

        for (var productOptionValueIndex = 0; productOptionValueIndex < productOption.product_option.values.length; productOptionValueIndex++) {
          var productOptionValue = productOption.product_option.values[productOptionValueIndex];

          if (hasPriceInfo(productOptionValue)) {
            var productOptionValuePriceInfo = productOptionValue.product_option_value.price_info,
              comparedAmountsFormatted = priceHelper.compareAmounts(selectedProductOptionValuePriceInfo.additional_amount_display, productOptionValuePriceInfo.additional_amount_display, true),
              comparedAmounts = priceHelper.getAmountUnformatted(comparedAmountsFormatted);

            productOptionValuePriceInfo.additional_amount_display = parseInt(comparedAmounts);
            productOptionValuePriceInfo.additional_amount_display_formatted = comparedAmounts != 0 ? comparedAmountsFormatted : '';
          }
        }
      }
    }

    return productOption;
  }

  /**
   * Caches an product option value list as a reference to a UI option value list
   * @param  {Object} productOptionValueList A product option value list
   */
  function cacheVisibleProductOptionValuesList(productOptionValueList) {
    var dataCacheScoped = dataCache.options;
    dataCacheScoped.visible = productOptionValueList;
  }

  /**
   * Gets a product option from the product options list
   * @param {Number} productId The ID of the product the updated productOption belongs to
   * @param {Number} productOptionId THe ID of the product option for which we create the list
   * @return {Boolean|Object} A product option on success. FALSE on failure.
   */
  function getProductOptionForProductByProductOptionId(product, productOptionId) {
    var productOptions = getProductOptionListForProduct(product);

    for (var i = 0; i < productOptions.length; i++) {
      var currentProductOption = productOptions[i];
      if (currentProductOption.product_option.id == productOptionId) {
        currentProductOption.product_option.value = currentProductOption.product_option.values[currentProductOption.product_option.value_index].product_option_value.name;
        return currentProductOption;
      }
    }

    return false;
  }

  /**
   * Prepares some data that is needed for the hide process of a product option value list
   * @param {Number} productId The ID of the product the updated productOption belongs to
   * @param {Number} productOptionId THe ID of the product option for which we create the list
   * @return {Boolean} TRUE on success
   */
  function hideVisibleProductOptionValuesLists(productId, productOptionId) {
    var dataCacheScoped = dataCache.options,
      dataCacheRelevant = null,
      productOption = null,
      visibleProductOptionList = dataCacheScoped.visible ? dataCacheScoped.visible : null;


    if (productId && productOptionId) {
      dataCacheRelevant = isChildProduct(getProductByProductId(productId)) ? dataCacheScoped.children : dataCacheScoped.parent;
      productOption = dataCacheRelevant[productId][productOptionId];
    }

    if (visibleProductOptionList) {
      productOption = getProductOptionForProductByProductOptionId(getProductByProductId(visibleProductOptionList.product_option.product_id), visibleProductOptionList.product_option.id);
      _this.callPlugins('onHideProductOptionValuesList', productOption);
      dataCacheScoped.visible = null;
      return true;
    }
  }

  /**
   * Requested when a product option value ist is hidden
   * @param {Number} productId The ID of the product the updated productOption belongs to
   * @param {Number} productOptionId THe ID of the product option for which we create the list
   */
  function productOptionValueListIsHidden(productId, productOptionId) {}

  /**
   * Creates the productOptions for a product. The results will be available via the dataCache
   * @param {Object} product The product for which we create the data
   * @param {Boolean} TRUE if option data has been created. FALSE if not.
   */
  function createProductOptions(product) {
    // a new child product was selected. so we have to remove the data of the previous child from the selectedValues
    removeOldDataFromSelectedValues('options');

    // the current product has no options. so we can skip the following processes
    if (!productHasOptions(product)) {
      return null;
    }

    // initialize the cache if it hasn't already be done
    if (!dataCache.options) {
      dataCache.options = {
        parent: {},
        children: {}
      };
    }

    if (!dataCache.option_values) {
      dataCache.option_values = {
        parent: [],
        children: []
      };
    }

    var productId = product.product.id,
      productOptions = product.product.options,
      productOptionsSelectedValues = selectedValues.options && selectedValues.options[productId] ? selectedValues.options[productId] : null,
      dataCacheScoped = dataCache.options,
      dataCacheRelevant = isChildProduct(product) ? dataCacheScoped.children : dataCacheScoped.parent,
      cachedProductOptions = {};

    // lets check if we already created data for this product
    removeOldDataFromDataCache('options', dataCacheRelevant, productId);
    getProductExtensionData('options', dataCacheRelevant, product, productOptions, productOptionsSelectedValues, {
      get_selected_values: getSelectedProductOptionValue
    });

    return getProductOptionListForProduct(product);

    /**
     * Determines the id of a selected productOptionValue for the a productOption
     * @param {Object} product The product for which we create the data
     * @param {Object} productOption The productOption for which we want to determine a value
     * @param {Object} productOptionsSelectedValues The currently selected productOptionValues of all productOptions of the current product
     * @param {String} The selected productOptionValue
     */
    function getSelectedProductOptionValue(product, productOption, productOptionsSelectedValues) {
      var selectedProductOptionValueId = null;

      if (!coreInitialized && productOptionsSelectedValues && productOptionsSelectedValues[productOption.product_option.id]) {
        // if the ProductDetailsCore isn't already initialized we can try to get a value via the selectedValues
        selectedProductOptionValueId = parseInt(productOptionsSelectedValues[productOption.product_option.id]);
      } else if (isChildProduct(product)) {
        // alternatively we search for a value id from one of the product options that are already in the dataCache
        selectedProductOptionValueId = getProductOptionValueIdFromCache(product, productOption);
      }

      // we non't have a selected value till now
      if (!selectedProductOptionValueId) {
        var productOptionValues = productOption.product_option.values,
          orderedProductOptionValues = [];

        for (var productOptionValueIndex in productOptionValues) {
          var productOptionValue = productOptionValues[productOptionValueIndex];
          orderedProductOptionValues.push(productOptionValue);
        }

        // sort the just created array with an appropriate algorithm and select the first productOptionValue
        orderedProductOptionValues = sortProductOptionValues(product, productOption, orderedProductOptionValues);

        selectedProductOptionValueId = parseInt(orderedProductOptionValues[0].product_option_value.id);
      }

      // put the collected data into the productOptionValue cache
      setProductOptionValue(product, productOption, selectedProductOptionValueId);

      return selectedProductOptionValueId;

      /**
       * Gets the current selected value id for a productOption from the value cache
       * @param {Object} product The product for which we want to get the data
       * @param {Object} productOption The productOption for which we want to determine a value
       * @param {String} The productOption value id
       */
      function getProductOptionValueIdFromCache(product, productOption) {
        var dataCacheScope = dataCache.option_values,
          dataCacheRelevant = isParentProduct(product) ? dataCacheScope.parent : dataCacheScope.children,
          foundProductOptionValueId = null;

        // search for a matching entry in the input field value cache
        outerLoop:
          for (var cachedProductOptionValueIndex = 0; cachedProductOptionValueIndex < dataCacheRelevant.length; cachedProductOptionValueIndex++) {
            var cachedProductOptionValue = dataCacheRelevant[cachedProductOptionValueIndex];

            if (cachedProductOptionValue.name == productOption.product_option.name) {
              for (var productOptionValueId in productOption.product_option.values) {
                var productOptionValue = productOption.product_option.values[productOptionValueId];

                if (productOptionValue.product_option_value.name == cachedProductOptionValue.value) {
                  foundProductOptionValueId = productOptionValue.product_option_value.id;
                  break outerLoop;
                }
              }

              break;
            }
          }

        return foundProductOptionValueId;
      }
    }
  }

  /**
   * Sets the current value for a productOption to the value cache
   * @param {Object} product The product for which we want to get the data
   * @param {Object} productOption The productOption for which we want to determine a value
   * @param {Number} productOptionValueId The id of the selected productOptionValue in the current productOption
   */
  function setProductOptionValue(product, productOption, productOptionValueId) {
    var dataCacheScope = dataCache.option_values,
      dataCacheRelevant = isParentProduct(product) ? dataCacheScope.parent : dataCacheScope.children,
      productOptionValueCacheFound = false,
      productOptionValueIndex = getProductOptionValueIndexForOptionValueId(product, productOption, productOptionValueId);

    // update the product option with the new value information
    productOption.product_option.value = productOption.product_option.values[productOptionValueId].product_option_value.name;
    productOption.product_option.value_id = productOption.product_option.values[productOptionValueId].product_option_value.id;
    productOption.product_option.value_index = productOptionValueIndex;

    // search for a matching entry in the input field value cache
    for (var cachedProductOptionValueIndex = 0; cachedProductOptionValueIndex < dataCacheRelevant.length; cachedProductOptionValueIndex++) {
      var cachedProductOptionValue = dataCacheRelevant[cachedProductOptionValueIndex];

      // we found a valid entry
      if (cachedProductOptionValue.name && cachedProductOptionValue.name == productOption.product_option.name) {
        // update the value
        cachedProductOptionValue.value = productOption.product_option.value;

        var relatedProductOptionFound = false;

        // check if this product option is already listed in the related product options list
        for (var relatedProductOptionIndex = 0; relatedProductOptionIndex < cachedProductOptionValue.related_product_options.length; relatedProductOptionIndex++) {
          var relatedProductOption = cachedProductOptionValue.related_product_options[relatedProductOptionIndex];

          if (relatedProductOption.product_id == product.product.id && relatedProductOption.product_option_id == productOption.product_option.id) {
            relatedProductOptionFound = true;
            break;
          }
        }

        // add the product option to the related product options
        if (!relatedProductOptionFound) {
          cachedProductOptionValue.related_product_options.push({
            product_id: product.product.id,
            product_option_id: productOption.product_option.id
          });
        }

        // update the related productOptions
        updateRelatedProductOptions(product, productOption, cachedProductOptionValue.related_product_options, productOptionValueId);

        productOptionValueCacheFound = true;
        break;
      }
    }

    // add a new entry to the cache if it hasn't already been done
    if (!productOptionValueCacheFound) {
      var newProductOptionValueCacheEntry = {
        name: productOption.product_option.name,
        value: productOption.product_option.value,
        related_product_options: [{
          product_id: product.product.id,
          product_option_id: productOption.product_option.id
        }]
      };

      // update the related productOptions
      updateRelatedProductOptions(product, productOption, newProductOptionValueCacheEntry.related_product_options, productOptionValueId);

      dataCacheRelevant.push(newProductOptionValueCacheEntry);
    }

    function updateRelatedProductOptions(product, productOption, relatedProductOption, productOptionValueId) {
      var dataCacheScope = dataCache.options,
        dataCacheRelevant = isParentProduct(product) ? dataCacheScope.parent : dataCacheScope.children;

    }
  }

  /**
   * Gets the index of a productOptionValue in an ordered productOptionValue list
   * @param {Object} product 					The product for which we want to get the data
   * @param {Object} productOption 			The productOption for which we want to determine a value
   * @param {Number} productOptionValueId 	The id of the requested productOptionValue
   * @return {Number}                      	The requested index
   */
  function getProductOptionValueIndexForOptionValueId(product, productOption, productOptionValueId) {
    var orderedProductOptionValues = [],
      selectedProductOptionValueIndex = null;

    // transform the productOptionValue object into an array. we must have sorted
    // productOptionValues to determine the new selected_value_index
    for (var productOptionValueIndex in productOption.product_option.values) {
      var productOptionValue = productOption.product_option.values[productOptionValueIndex];
      orderedProductOptionValues.push(productOptionValue);
    }

    // order the productOptionValues
    orderedProductOptionValues = sortProductOptionValues(product, productOption, orderedProductOptionValues);

    // search for the new selected productOptionValue in the sorted list
    for (var orderedProductOptionValueIndex = 0; orderedProductOptionValueIndex < orderedProductOptionValues.length; orderedProductOptionValueIndex++) {
      var orderedProductOptionValue = orderedProductOptionValues[orderedProductOptionValueIndex];

      if (orderedProductOptionValue.product_option_value.id == productOptionValueId) {
        selectedProductOptionValueIndex = orderedProductOptionValueIndex;
        break;
      }
    }

    return selectedProductOptionValueIndex;
  }


  /*********************************************
   * PRODUCT INPUT FIELDS
   *********************************************/

  /**
   * Updates value of a product input field
   * @param {String} productId The ID of the product the updated productInputField belongs to
   * @param {String} productInputFieldId The ID of the productInputField the updated value belongs to
   * @param {String} productInputFieldValue The new value of the productInputField
   * @param {Array} The updated productOptions
   */
  function updateProductInputFieldValue(productId, productInputFieldId, productInputFieldValue) {
    if (!validateSelectedValuesDataForUpdate('input_fields', productId, productInputFieldId)) {
      return false;
    }

    var product = null,
      productInputField = null,
      productInputFieldCacheEntry = getProductAndCacheEntryFromCache('input_fields', dataCache.input_fields, productId, productInputFieldId);

    product = productInputFieldCacheEntry.product;
    productInputField = productInputFieldCacheEntry.cache_entry;

    // update the selected values
    selectedValues.input_fields[productId][productInputFieldId] = productInputFieldValue;
    saveSelectedValuesinHistory();

    // update the value of the productInputField and the productInputFieldValueCache
    setProductInputFieldValue(product, productInputField, productInputFieldValue);

    // check if the productInputFields have a valid state to allow to put the product into the cart
    checkProductInputFieldRequiredStatus();

    var productInputFieldForPlugin = getProductInputFieldListForProduct(product, productInputField.product_input_field.id);

    _this.callPlugins('onUpdateProductInputField', productInputFieldForPlugin);

    updateProductPriceInfo();

    return true;
  }

  /**
   * Creates a list of ordered productInputFields for a specified product
   * @param {Object} product The product for which we create the list
   * @param {Array} The ordered list
   */
  function getProductInputFieldListForProduct(product, productInputFieldId) {
    if (
      !productHasInputFields(product)
      || isStepByStepMode()
      && !_this.getState(_this.getProductSelectionStates().STATE_STEPBYSTEP_SELECTION_DONE)
    ) {
      return [];
    }

    var dataCacheRelevant = isChildProduct(product) ? dataCache.input_fields.children[product.product.id] : dataCache.input_fields.parent[product.product.id],
      orderedProductInputFields = [];

    // transform the input object to an array that can be sorted
    for (var cachedProductInputFieldId in dataCacheRelevant) {
      var cachedProductInputField = dataCacheRelevant[cachedProductInputFieldId];

      // update the is_valid status for fields with required input
      setProductInputFieldIsValidStatus(cachedProductInputField);

      if (productInputFieldId) {
        if (cachedProductInputField.product_input_field.id == productInputFieldId) {
          return cachedProductInputField;
        }
      } else {
        orderedProductInputFields.push(cachedProductInputField);
      }
    }

    // sort and return
    return sortProductInputFields(product, orderedProductInputFields);
  }

  /**
   * Creates the productInputFields for a product. The results will be available via the dataCache
   * @param {Object} product The product for which we create the data
   * @param {Boolean} TRUE if productInputFields data has been created. FALSE if not.
   */
  function createProductInputFields(product) {
    // a new child product was selected. so we have to remove the data of the previous child from the selectedValues
    removeOldDataFromSelectedValues('input_fields');

    // the current product has no input fields. so we can skip the following processes
    if (!productHasInputFields(product)) {
      return null;
    }

    // initialize the cache if it hasn't already be done
    if (!dataCache.input_fields) {
      dataCache.input_fields = {
        parent: {},
        children: {}
      };
    }

    if (!dataCache.input_field_values) {
      dataCache.input_field_values = {
        parent: [],
        children: []
      };
    }

    var productId = product.product.id,
      productInputFields = product.product.input_fields,
      productInputFieldsSelectedValues = selectedValues.input_fields && selectedValues.input_fields[productId] ? selectedValues.input_fields[productId] : null,
      dataCacheScoped = dataCache.input_fields,
      dataCacheRelevant = isChildProduct(product) ? dataCacheScoped.children : dataCacheScoped.parent,
      cachedProductInputFields = {};

    // lets check if we already created data for this product
    removeOldDataFromDataCache('input_fields', dataCacheRelevant, productId);
    getProductExtensionData('input_fields', dataCacheRelevant, product, productInputFields, productInputFieldsSelectedValues, {
      get_selected_values: getSelectedProductInputFieldValues
    });

    return getProductInputFieldListForProduct(product);

    /**
     * Determines a value for the a productInputField
     * @param {Object} product The product for which we create the data
     * @param {Object} productInputField The productInputField for which we want to determine a value
     * @param {Object} productOptionsSelectedValues The current values of all productInputFields of the current product
     * @param {String} The productInputField value
     */
    function getSelectedProductInputFieldValues(product, productInputField, productInputFieldsSelectedValues) {
      var productInputFieldValue = "";

      if (!coreInitialized && productInputFieldsSelectedValues && productInputFieldsSelectedValues[productInputField.product_input_field.id]) {
        // if the ProductDetailsCore isn't already initialized we can try to get a value via the selectedInputs
        productInputFieldValue = productInputFieldsSelectedValues[productInputField.product_input_field.id];
      } else if (isChildProduct(product)) {
        productInputFieldValue = getProductInputFieldValueFromCache(product, productInputField);
      }

      setProductInputFieldValue(product, productInputField, productInputFieldValue);
      return productInputFieldValue;
    }

    /**
     * Gets the current value for a productInputField from the value cache
     * @param {Object} product The product for which we want to get the data
     * @param {Object} productInputField The productInputField for which we want to determine a value
     * @param {String} The productInputField value
     */
    function getProductInputFieldValueFromCache(product, productInputField) {
      var dataCacheScope = dataCache.input_field_values,
        dataCacheRelevant = isParentProduct(product) ? dataCacheScope.parent : dataCacheScope.children,
        foundProductInputFieldValue = '';

      // search for a matching entry in the input field value cache
      for (var cachedProductInputFieldValueIndex = 0; cachedProductInputFieldValueIndex < dataCacheRelevant.length; cachedProductInputFieldValueIndex++) {
        var cachedProductInputFieldValue = dataCacheRelevant[cachedProductInputFieldValueIndex];

        if (cachedProductInputFieldValue.name == productInputField.product_input_field.label) {
          foundProductInputFieldValue = cachedProductInputFieldValue.value;
          break;
        }
      }

      return foundProductInputFieldValue;
    }
  }

  /**
   * Sets the current value for a productInputField to the value cache
   * @param {Object} product The product for which we want to set the data
   * @param {Object} productInputField The productInputField for which we want to set a value
   * @param {Object} productInputFieldValue The designated value of the productInputField
   */
  function setProductInputFieldValue(product, productInputField, productInputFieldValue) {
    var dataCacheScope = dataCache.input_field_values,
      dataCacheRelevant = isParentProduct(product) ? dataCacheScope.parent : dataCacheScope.children,
      productInputFieldValueCacheFound = false;

    productInputField.product_input_field.value = productInputFieldValue;

    // search for a matching entry in the input field value cache
    for (var cachedProductInputFieldValueIndex = 0; cachedProductInputFieldValueIndex < dataCacheRelevant.length; cachedProductInputFieldValueIndex++) {
      var cachedProductInputFieldValue = dataCacheRelevant[cachedProductInputFieldValueIndex];

      // we found a valid entry
      if (cachedProductInputFieldValue.name && cachedProductInputFieldValue.name == productInputField.product_input_field.label) {

        // update the value
        cachedProductInputFieldValue.value = productInputFieldValue;

        var relatedProductInputFieldFound = false;

        // check if this product input field is already listed in the related product input fields list
        for (var relatedProductInputFieldIndex = 0; relatedProductInputFieldIndex < cachedProductInputFieldValue.related_product_input_fields.length; relatedProductInputFieldIndex++) {
          var relatedProductInputField = cachedProductInputFieldValue.related_product_input_fields[relatedProductInputFieldIndex];

          if (relatedProductInputField.product_id == product.product.id && relatedProductInputField.product_input_field_id == productInputField.product_input_field.id) {
            relatedProductInputFieldFound = true;
            break;
          }
        }

        // add the product input field to the related product input fields
        if (!relatedProductInputFieldFound) {
          cachedProductInputFieldValue.related_product_input_fields.push({
            product_id: product.product.id,
            product_input_field_id: productInputField.product_input_field.id
          });
        }

        // update the related productInputFields
        updateRelatedProductInputFields(product, productInputField, cachedProductInputFieldValue.related_product_input_fields, productInputFieldValue);

        productInputFieldValueCacheFound = true;
        break;
      }
    }

    // add a new entry to the cache if it hasn't already been done
    if (!productInputFieldValueCacheFound) {
      var newFieldValueCacheEntry = {
        name: productInputField.product_input_field.label,
        value: productInputFieldValue,
        related_product_input_fields: [{
          product_id: product.product.id,
          product_input_field_id: productInputField.product_input_field.id
        }]
      };

      // update the related productInputFields
      updateRelatedProductInputFields(product, productInputField, newFieldValueCacheEntry.related_product_input_fields, productInputFieldValue);

      dataCacheRelevant.push(newFieldValueCacheEntry);
    }

    /**
     * Updates the value for the related productInputFields of a specified productInputField
     * @param {Object} product The product for which we want to set the data
     * @param {Object} productInputField The productInputField for which we want to set a value
     * @param {Array} relatedProductInputFields A list of related productInputFields to the current productInputField
     * @param {Object} productInputFieldValue The designated value of the productInputField
     */
    function updateRelatedProductInputFields(product, productInputField, relatedProductInputFields, productInputFieldValue) {
      var dataCacheScope = dataCache.input_fields,
        dataCacheRelevant = isParentProduct(product) ? dataCacheScope.parent : dataCacheScope.children;

      for (var relatedProductInputFieldIndex = 0; relatedProductInputFieldIndex < relatedProductInputFields.length; relatedProductInputFieldIndex++) {
        var relatedProductInputField = relatedProductInputFields[relatedProductInputFieldIndex];

        if (dataCacheRelevant[relatedProductInputField.product_id] &&
          dataCacheRelevant[relatedProductInputField.product_id][relatedProductInputField.product_input_field_id]) {
          dataCacheRelevant[relatedProductInputField.product_id][relatedProductInputField.product_input_field_id].product_input_field.value = productInputFieldValue;
        }
      }
    }
  }

  /**
   * Removes the old input fields and options product data from the selectedValues
   * @param {String} dataType The type of the old data (options and input_fields)
   */
  function removeOldDataFromSelectedValues(dataType) {
    var validDataTypes = ['options', 'input_fields'];

    if (validDataTypes.indexOf(dataType) === -1) {
      return false;
    }

    // a new child product was selected. so we have to remove the data of the previous child from the selectedValues
    if (coreInitialized && selectedValues[dataType]) {
      for (var productId in selectedValues[dataType]) {
        // the current productId isn't the id of the parent product. so we can delete it.
        // currently the inputFields section values will contain one entry for the parentProduct
        // and one entry of a childProduct at max.
        if (getParentProductId() != productId) {
          debugConsole.warn('Old %s value deleted (%s)', dataType, productId);
          delete(selectedValues[dataType][productId]);
        }
      }
    }
  }

  /**
   * Gets an old stack of data from the data cache
   * @param {String} dataType The type of the old data (options and input_fields)
   * @param {Object} relevantDataCache The dataCache for the type of data
   * @param {Number} productId The ID of the product for which we collect the cache data
   */
  function removeOldDataFromDataCache(dataType, relevantDataCache, productId) {
    var validDataTypes = ['options', 'input_fields'];

    if (validDataTypes.indexOf(dataType) === -1) {
      return false;
    }

    // lets check if we already created data for this product
    if (relevantDataCache[productId]) {
      // copy the cached data
      var dataFromCache = relevantDataCache[productId];

      // there are cached input fields. so we can update the selectedValues
      if (Object.keys(dataFromCache).length > 0) {
        selectedValues[dataType][productId] = {};

        for (var cachedDataIndex in dataFromCache) {
          var cachedData = dataFromCache[cachedDataIndex],
            newValue = null,
            typeField = null;

          switch (dataType) {
            case 'options':
              newValue = cachedData.product_option.value_id;
              typeField = 'product_option';
              break;
            case 'input_fields':
              newValue = cachedData.product_input_field.value;
              typeField = 'product_input_field';
              break;
            default:
              break;
          }

          selectedValues[dataType][productId][cachedData[typeField].id] = newValue;
        }
      }

      saveSelectedValuesinHistory();

      debugConsole.info('%s cache hit for %s', dataType, productId);

      return true;
    }
  }

  /**
   * Check on option and input field updates if the requested element is really selected
   * @param {String} dataType The type of the old data (options and input_fields)
   * @param {Number} productId The ID of the product for which we collect the cache data
   * @param {Number} selectedEntryId The ID of one currently selected option or input field
   * @return TRUE on validation success. FALSE if it fails
   */
  function validateSelectedValuesDataForUpdate(dataType, productId, selectedEntryId) {
    var validDataTypes = ['options', 'input_fields'];

    if (validDataTypes.indexOf(dataType) === -1) {
      return false;
    }

    if (!selectedValues[dataType] ||
      !selectedValues[dataType][productId] ||
      typeof selectedValues[dataType][productId][selectedEntryId] == 'undefined') {
      debugConsole.warn('validateSelectedValuesDataForUpdate: %s - update failed %s %s', dataType, productId, selectedEntryId);
      return false;
    }

    return true;
  }

  /**
   * Gets an old stack of data from the data cache
   * @param {String} dataType The type of the old data (options and input_fields)
   * @param {Object} relevantDataCache The dataCache for the type of data
   * @param {Number} productId The ID of the product for which we collect the cache data
   * @param {Number} dataCacheEntryId The ID of the entry for which we collect the cache data
   */
  function getProductAndCacheEntryFromCache(dataType, relevantDataCache, productId, dataCacheEntryId) {
    var validDataTypes = ['options', 'input_fields'],
      isChildProduct = false,
      dataCacheEntry = null;

    if (validDataTypes.indexOf(dataType) === -1) {
      return false;
    }

    if (relevantDataCache.children[productId] && relevantDataCache.children[productId][dataCacheEntryId]) {
      dataCacheEntry = relevantDataCache.children[productId][dataCacheEntryId];
      isChildProduct = true;
    } else if (relevantDataCache.parent[productId] && relevantDataCache.parent[productId][dataCacheEntryId]) {
      dataCacheEntry = relevantDataCache.parent[productId][dataCacheEntryId];
    }

    if (!dataCacheEntry ||
      typeof selectedValues[dataType][productId][dataCacheEntryId] == 'undefined') {
      debugConsole.error('getProductAndCacheEntryFromCache: type: %s | productId: %s | dataCacheEntryId: %s | Not updatable', dataType, productId, dataCacheEntryId);
      return false;
    }

    debugConsole.info('%s update cache hit for %s', dataType, productId);

    // get the right product form the product list
    return {
      product: !isChildProduct ? products.parent : products.children[productId],
      cache_entry: dataCacheEntry
    };
  }

  /**
   * Collects data about product extensions (options and input_fields)
   * @param {String} dataType The type of the old data (options and input_fields)
   * @param {Object} relevantDataCache The dataCache for the type of data
   * @param {Object} product The product the extensions belong to
   * @param {Object} productExtensionElements List of product extension elements that belong to the product
   * @param {Object} productExtensionSelectedValues List the current values of the extension elements
   * @param {Object} productExtensionSiblings List of siblings of the current extension element - only needed with child products
   * @param {Object} productExtensionFunctions
   * @param {Function} productExtensionFunctions.get_selected_values A function that gets selected values for the current extension type
   */
  function getProductExtensionData(dataType, relevantDataCache, product, productExtensionElements, productExtensionSelectedValues, productExtensionFunctions) {
    var validDataTypes = ['options', 'input_fields'],
      mappedTypeName = dataType == 'options' ? 'product_option' : 'product_input_field',
      productId = getProductId(product),
      productExtensionNameIdMapping = [],
      productExtensionNames = [];

    if (validDataTypes.indexOf(dataType) === -1) {
      return false;
    }

    // according to the specififaciton product extension names must be unique.
    // to be on the safe side we check this and correct them if necessary
    for (var productExtensionElementsIndex in productExtensionElements) {
      var productExtension = productExtensionElements[productExtensionElementsIndex];
      productExtensionNameIdMapping.push(productExtension[mappedTypeName].id);
      productExtensionNames.push(dataType == 'options' ? productExtension[mappedTypeName].name : productExtension[mappedTypeName].label);
    }

    _uniquifyProductExtensionNames();

    // loop through the extension data
    for (var productExtensionElementsIndex in productExtensionElements) {
      var productExtension = productExtensionElements[productExtensionElementsIndex],
        productExtensionId = productExtension[mappedTypeName].id;

      // at this point in code we know that we will have at least one valid productExtension for the view.
      // so we can add a new basic entry for the current product in the selectedValues object if isn't already present
      if (productExtensionSelectedValues === null) {
        if (!selectedValues[dataType]) {
          selectedValues[dataType] = {};
        }

        selectedValues[dataType][productId] = {};
        productExtensionSelectedValues = selectedValues[dataType][productId];
      }

      // determine the current selected extensionValue
      productExtensionSelectedValues[productExtensionId] = productExtensionFunctions.get_selected_values(product, productExtension, productExtensionSelectedValues);

      // sanitize the product extension data
      sanitizeProductData(mappedTypeName, productExtension, true);

      if (dataType == 'options') {
        for (var productOptionValues in productExtension[mappedTypeName].values) {
          sanitizeProductData('product_option_value', productExtension[mappedTypeName].values[productOptionValues], true);
        }

        // put the selected value into the extension
        productExtension[mappedTypeName].value = productExtension[mappedTypeName].values[productExtensionSelectedValues[productExtensionId]].product_option_value.name;

        // put the selected value_id into the extension
        productExtension[mappedTypeName].value_id = productExtensionSelectedValues[productExtensionId];
      } else if (dataType == 'input_fields') {
        // put the selected value into the extension
        productExtension[mappedTypeName].value = productExtensionSelectedValues[productExtensionId];
      }
    }

    // put the data into the cache
    relevantDataCache[productId] = productExtensionElements;

    /**
     * Because product extensions are referenced by name it must be guaranteed that we have unique names.
     * By specifications product extensions have unique names, but to be on the safe side this has to be checked.
     */
    function _uniquifyProductExtensionNames() {
      for (var i = 0; i < productExtensionNames.length; i++) {
        var currentName = productExtensionNames[i],
          duplicateCounter = 1;

        // we found at least one duplicate. so we search for more
        if (productExtensionNames.indexOf(currentName, i + 1) != -1) {
          productExtensionNames[i] = _uniquify(productExtensionNames[i], duplicateCounter);

          for (var j = i + 1; j < productExtensionNames.length; j++) {
            if (productExtensionNames.indexOf(currentName, j) != -1) {
              duplicateCounter++;
              productExtensionNames[productExtensionNames.indexOf(currentName, j)] = _uniquify(productExtensionNames[productExtensionNames.indexOf(currentName, j)], duplicateCounter);
            }
          }
        }
      }

      // overwrite the product extension names with the modified names
      for (var i = 0; i < productExtensionNames.length; i++) {
        if (dataType == 'options') {
          productExtensionElements[productExtensionNameIdMapping[i]][mappedTypeName].name = productExtensionNames[i];
        } else {
          productExtensionElements[productExtensionNameIdMapping[i]][mappedTypeName].label = productExtensionNames[i];
        }
      }

      /**
       * Makes the product extension name unique
       * @param  {String} value            The name
       * @param  {Number} duplicateCounter The duplicate counter index
       * @return {String}                  The modified name
       */
      function _uniquify(value, duplicateCounter) {
        var suffix = '';
        // add invisible spaces if functionality is provided
        if (typeof $.shopgate !== 'undefined' && typeof $.shopgate.decodeHTMLEntities == 'function') {
          for (var i = 0; i < duplicateCounter; i++) {
            suffix += $.shopgate.decodeHTMLEntities(options.emptyProductAttributeKeyPlaceholder);
          }
        } else {
          suffix = value + " (" + duplicateCounter + ")";
        }

        return value + suffix;
      }
    }
  }

  /*********************************************
   * PRODUCT ATTRIBUTES
   *********************************************/

  /**
   * Creates a list of productAttributes based on a productId and a productAttributeId and passes it to the UI
   * @param {String} productId The ID of the product the updated productInputField belongs to
   * @param {String} productAttributeId The ID of the productAttribute the updated value belongs to
   * @param {Boolean} returnMode - If no callback should be called, but data should be returned instead.
   */
  function getProductAttributeValuesForProductAttributeId(productId, productAttributeId, returnMode) {
    var product = getProductByProductId(productId),
      dataCacheScoped = dataCache.attributes,
      currentProductAttributeValue = null,
      productAttributeValuesList = null;
    if (typeof returnMode === 'undefined') {
      returnMode = false;
    }

    if (isProduct(product)) {
      currentProductAttributeValue = dataCacheScoped.selected[productAttributeId] ? dataCacheScoped.selected[productAttributeId].product_attribute.value : null;

      if (currentProductAttributeValue && !checkIsAttributeListVisible(productId, productAttributeId)) {
        productAttributeValuesList = getCurrentAttributeValueList(product, productAttributeId);

        if (returnMode === true) {
          return {
            product_attribute: productAttributeValuesList[0].product_attribute
          };
        }

        if (productHasOptions(product)) {
          hideVisibleProductOptionValuesLists();
        }

        hideVisibleProductAttributeValuesLists();

        cacheVisibleProductAttributeList(productAttributeValuesList[0]);

        _this.callPlugins('onShowProductAttributeValuesList', {
          product_attribute: productAttributeValuesList[0].product_attribute
        });
        return true;
      }
    }

    return false;
  }

  /**
   * Prepares some data that is needed for the hide process of a product attributes value list
   * @param {String} productId The ID of the product the updated productInputField belongs to
   * @param {String} productAttributeId The ID of the productAttribute the updated value belongs to
   * @return {Boolean} TRUE on success
   */
  function hideVisibleProductAttributeValuesLists(productId, productAttributeId) {
    var dataCacheScoped = dataCache.attributes,
      visibleProductAttributeList = dataCacheScoped.visible ? dataCacheScoped.visible : null;

    if (visibleProductAttributeList) {
      _this.callPlugins('onHideProductAttributeValuesList', {
        product_attribute: visibleProductAttributeList.product_attribute
      });
      dataCacheScoped.visible = null;
      return true;
    } else {
      return false;
    }
  }

  /**
   * Requested when a product attribute value list is hidden
   * @param {String} productId The ID of the product the updated productInputField belongs to
   * @param {String} productAttributeId The ID of the productAttribute the updated value belongs to
   */
  function productAttributeValueListIsHidden(productId, productAttributeId) {
    var dataCacheScoped = dataCache.attributes;

    /**
     * The callback that is fired when the UI data is completely prepared by the core
     * @param  {Object} callbackData The data for the UI
     */
    function updateSuccessCallback(callbackData) {
      triggerOnUpdateProductEvent(callbackData);
      dataCacheScoped.visible = null;
      dataCacheScoped.product_id_for_update = null;
      updateProductPriceInfo();
    }

    if (dataCacheScoped.product_id_for_update) {
      selectChildProduct(dataCacheScoped.product_id_for_update, updateSuccessCallback);
    }

    return true;
  }

  /**
   * Caches an product attribute value list as a reference to a UI attribute value list
   * @param  {Object} productAttributenValueList A product attribute value list
   */
  function cacheVisibleProductAttributeList(productAttributeList) {
    var dataCacheScoped = dataCache.attributes;

    dataCacheScoped.visible = productAttributeList;
  }

  /**
   * Checks if a product attribute list is currently visibile in the UI
   * @param {String} productId The ID of the product the updated productInputField belongs to
   * @param {String} productAttributeId The ID of the productAttribute the updated value belongs to
   */
  function checkIsAttributeListVisible(productId, productAttributeId) {
    var dataCacheScoped = dataCache.attributes,
      visibleProductAttributeList = dataCacheScoped.visible ? dataCacheScoped.visible : null;

    if (visibleProductAttributeList && visibleProductAttributeList.product_attribute.product_id == productId && visibleProductAttributeList.product_attribute.id == productAttributeId) {
      return true;
    }
    return false;
  }

  /**
   * Request the selection of a new child product via the change of a product attribute value
   * @param {String} productId The ID of the current selected product
   * @param {String} productAttributeId The index of the productAttribute that has to be changed
   */
  function updateSelectedProductAttributeValue(productId, productAttributeId, options) {
    var stdOptions = {
      forceUpdate: false
    };

    options = $.extend({}, stdOptions, options);
    if (typeof dataCache.attributes === 'undefined') {

      return false;
    }
    var dataCacheScoped = dataCache.attributes;
    if (productAttributeId) {
      dataCacheScoped.lastChosenAttribute = productAttributeId - 1;
    } else {
      dataCacheScoped.lastChosenAttribute = null;
    }
    // only update if we have a product id of a valid product that isn't the currently selected product
    if (productId && getProductByProductId(productId) && (options.forceUpdate || productId != selectedValues.product_id)) {
      dataCacheScoped.product_id_for_update = productId;
    }

    hideVisibleProductAttributeValuesLists();
  }

  /**
   * Initializes the ShopgateProductDetailsCore for products with attributes
   * @return {Boolean} TRUE on a successful initialization. FALSE on failure.
   */
  function initializeProductAttributes() {

    // ensure that the core isn't initialized and we really have childProducts
    if (coreInitialized || !productHasChildProducts(getParentProduct())) {
      return false;
    }

    // perform some checks on the attribute structure and validate it (optional)
    var productAttributesAreValid = analyzeProductAttributes(performProductAttributeValidation);
    var dataCacheScoped = dataCache.attributes;

    if (!productAttributesAreValid) {
      return productAttributesAreValid;
    }

    // collect some information about the available productAttributeKeys and productAttributeValues
    for (var productAttributeId = 1; productAttributeId <= dataCacheScoped.counters.parent[getParentProductId()].values; productAttributeId++) {
      dataCacheScoped.available[productAttributeId] = createProductAttributeListForProductAttributeId(productAttributeId);
    }

    var expectedChildProductCounter = null,
      childProductCounter = Object.keys(products.children).length;

    for (var availableAttributeId in dataCacheScoped.available) {
      var availableAttribute = dataCacheScoped.available[availableAttributeId];
      if (expectedChildProductCounter === null) {
        expectedChildProductCounter = availableAttribute.product_attribute.values.length;
      } else {
        expectedChildProductCounter = expectedChildProductCounter * availableAttribute.product_attribute.values.length;
      }
    }

    if (childProductCounter < expectedChildProductCounter) {
      dataCache.products_complete = false;

      // we don't have products for all attribute combinations but the product has only 2 attributes.
      // so we can activate a save mode for this situation
      if (dataCacheScoped.counters.parent[getParentProductId()].values == 2) {
        dataCache.productSelectionMode = productSelectionModes.INCOMPLETE_PRODUCTS_WITH_TWO_ATTRIBUTES;
        options.allowProductSuggestions = true;
      }

      debugConsole.warn("initializeProductAttributes: fewer child products than expected. products: %s | expected: %s | %s fewer", childProductCounter, expectedChildProductCounter, expectedChildProductCounter - childProductCounter);
    } else {
      dataCache.products_complete = true;
    }

    return true;

    /**
     * Creates a list of all possible product attribute values for a product attribute id
     * @param {Number} productAttributeId The id of the product attribute
     * @return {Object}
     * @return {String} return.name The name of the product attribute key
     * @return {Number} return.id The id of the product attribute key
     * @return {Array}	return.values An array of sorted values for this product attribute key
     */
    function createProductAttributeListForProductAttributeId(productAttributeId) {
      var productAttributeName = products.parent.product['attribute_' + productAttributeId] ? products.parent.product['attribute_' + productAttributeId] : null,
        productAttributeValues = [],
        productAttributeList = {
          product_attribute: {
            name: productAttributeName,
            id: productAttributeId,
            values: []
          }
        };

      // get all possible productAttributeValues for the current productAttribute
      for (var childProductId in products.children) {
        var childProduct = products.children[childProductId];

        if (productAttributeValues.indexOf(childProduct.product['attribute_' + productAttributeId]) === -1) {
          productAttributeValues.push(childProduct.product['attribute_' + productAttributeId]);
        }
      }

      // sort the productAttributeValues
      productAttributeList.product_attribute.values = sortProductAttributeValuesList(productAttributeName, productAttributeValues);

      return productAttributeList;
    }
  }

  /**
   * Checks integrity of the attribute lists of parent and child products
   * @return {Boolean} TRUE if everything seems ok. FALSE if not.
   */
  function analyzeProductAttributes(performProductAttributeValidation) {
    // create the necessary dataCache objects if they aren't already present
    if (typeof dataCache.attributes === 'undefined') {
      dataCache.attributes = {
        counters: {
          parent: {},
          children: {},
        },
        available: {},
        selected: {},
        lastChosenAttribute: null,
      };
    }

    var dataCacheLocalScope = dataCache.attributes.counters;

    /**
     * Does the check for a single product and sets the results to the dataCache
     * @param {Object} product The product for which we create the data
     */
    function checkAttributeCount(product) {
      var dataCacheRelevant = isChildProduct(product) ? dataCacheLocalScope.children : dataCacheLocalScope.parent,
          counterProductAttributeIds = 0,
          counterProductAttributeValues = 0,
          lastProductAttributeValue,
          productAttributeValueGapIndices = [];

      // check up to 20 attributes (in reality we have only 10)
      for (var attributeId = 1; attributeId <= 20; attributeId++) {
        // the attribute key exists
        if (typeof product.product['attribute_' + attributeId] !== 'undefined') {
          var productAttributeValue = product.product['attribute_' + attributeId];

          // trim the values
          if (typeof productAttributeValue == 'string') {
            product.product['attribute_' + attributeId] = productAttributeValue = productAttributeValue.trim();
          }

          counterProductAttributeIds++;

          // add an invisible space to empty attribute keys if they have a value at the same attribute index
          if (isParentProduct(product) && productHasChildProducts(product) && productAttributeValue.length === 0) {
            for (var childProductId in products.children) {
              var childProduct = products.children[childProductId];
              if (childProduct.product['attribute_' + attributeId]) {
                var attributePlaceholder = '-';

                if (typeof $.shopgate !== 'undefined' && typeof $.shopgate.decodeHTMLEntities == 'function') {
                  attributePlaceholder = $.shopgate.decodeHTMLEntities(options.emptyProductAttributeKeyPlaceholder);
                }

                productAttributeValue = product.product['attribute_' + attributeId] = attributePlaceholder;

                debugConsole.warn("checkAttributeCount: used placeholder for attribute id %s", attributeId);
                break;
              }
            }
          }

          // the key has a valid value
          if (productAttributeValue.length > 0) {
            counterProductAttributeValues++;

            // check if we have a gap in the attribute list
            if (typeof lastProductAttributeValue != 'undefined' && !lastProductAttributeValue) {
              productAttributeValueGapIndices.push(attributeId - 1);
            }
          }

          lastProductAttributeValue = productAttributeValue;
        }
      }

      // prepare the results and push them into the dataCache
      var productAttributeCountResult = {
        ids: counterProductAttributeIds,
        values: counterProductAttributeValues,
        gap_indices: productAttributeValueGapIndices.length > 0 ? productAttributeValueGapIndices : []
      };

      dataCacheRelevant[product.product.id] = productAttributeCountResult;
    }

    // first we check the parent product
    checkAttributeCount(products.parent);

    // then we check the children
    for (var childProductId in products.children) {
      checkAttributeCount(products.children[childProductId]);
    }

    var hasAttributeErrors = false;

    // check if we have to validate the results of the productAttribute analysis
    if (performProductAttributeValidation) {
      var cachedParentProductCounterData = dataCacheLocalScope.parent[getParentProductId()];

      for (var cachedChildProductCounterDataId in dataCacheLocalScope.children) {
        var cachedChildProductCounterData = dataCacheLocalScope.children[cachedChildProductCounterDataId];
        // distinct attributeKey counters
        if (cachedParentProductCounterData.ids != cachedChildProductCounterData.ids) {
          hasAttributeErrors = true;
          debugConsole.warn('attributeValidation - key count mismatch: parent: %s, child %s: %s ', cachedParentProductCounterData.ids, cachedChildProductCounterDataId, cachedChildProductCounterData.ids);
        }

        // distinct attributeValue counters
        if (cachedParentProductCounterData.values != cachedChildProductCounterData.values) {
          hasAttributeErrors = true;
          debugConsole.warn('attributeValidation - value count mismatch: parent: %s, child %s: %s ', cachedParentProductCounterData.values, cachedChildProductCounterDataId, cachedChildProductCounterData.values);
        }

        // gaps in the childProduct attribute list
        if (cachedChildProductCounterData.gap_indices.length > 0) {
          hasAttributeErrors = true;
          debugConsole.warn('attributeValidation - child %s gaps at: %s,', cachedChildProductCounterDataId, cachedChildProductCounterData.gaps.join());
        }
      }

      // gaps in the parentProduct attribute list
      if (cachedParentProductCounterData.gap_indices.length > 0) {
        hasAttributeErrors = true;
        debugConsole.warn('attributeValidation - parent gaps at: %s,', cachedParentProductCounterData.gap_indices.join());
      }
    }

    return !hasAttributeErrors;
  }

  /**
   * Creates a list of all product attribute values for the product attributes of a product
   * @param {Object} product The product for which we create the data
   * @return {Object}
   */
  function createProductAttributes(product, removeProductAttributeValues) {
    if (!isChildProduct(product)) {
      debugConsole.error('createProductAttributess: ProductID: %s is not a child product', product.product.id);
      return null;
    }

    var dataCacheScoped = dataCache.attributes,
      productAttributeList = {};

    // loop through the attributes of the product
    for (var productAttributeId in dataCacheScoped.available) {
      var innerResult = {
        product_attribute: {
          id: parseInt(productAttributeId),
          name: products.parent.product['attribute_' + productAttributeId],
          value: product.product['attribute_' + productAttributeId],
          value_index: null
        }
      };

      // get the index of the currently selected productAttributeValue
      for (var productAttributeValueIndex = 0; productAttributeValueIndex < dataCacheScoped.available[productAttributeId].product_attribute.values.length; productAttributeValueIndex++) {
        if (dataCacheScoped.available[productAttributeId].product_attribute.values[productAttributeValueIndex]) {
          innerResult.product_attribute.value_index = productAttributeValueIndex;
          break;
        }
      }

      productAttributeList[productAttributeId] = innerResult;
    }

    dataCacheScoped.selected = productAttributeList;

    return getCurrentAttributeValueList(product, null, removeProductAttributeValues);
  }

  /**
   * Creates a datastructure that contains all requested value lists, ordered by the attributeKeyIndex
   * @param {Object} product The product for which we create the data
   * @param {Number} [optional] productAttributeId The index of an explicit attribute. If left empty the lists will be created for all attribtues
   * @return {Array} The datastructure
   */
  function getCurrentAttributeValueList(product, productAttributeId, removeProductAttributeValues) {
    var dataCacheScoped = dataCache.attributes,
      productAttributeValueList = [];

    /**
     * Creates the datastructure for a single product attribute
     * @param {Number} productAttributeId The id of the attribute the data should be created for
     */
    function addProductAttributeValueToList(productAttributeId, removeProductAttributeValues) {
      var productAttribute = dataCacheScoped.available[productAttributeId],
        productAttributeValueListEntry = {
          product_attribute: {
            id: productAttribute.product_attribute.id,
            name: productAttribute.product_attribute.name,
            product_id: parseInt(getProductId(product)),
            value: null,
            value_index: null,
            values: searchProductsForProductAttributeIdAndValue(productAttribute.product_attribute.id, product.product['attribute_' + productAttribute.product_attribute.id])
          }
        };

      for (var productAttributeValueIndex = 0; productAttributeValueIndex < productAttributeValueListEntry.product_attribute.values.length; productAttributeValueIndex++) {
        var productAttributeValue = productAttributeValueListEntry.product_attribute.values[productAttributeValueIndex];

        productAttributeValue.product_attribute_value.value_index = productAttributeValueIndex;

        if (productAttributeValue.product_attribute_value.selected === true) {
          productAttributeValueListEntry.product_attribute.value = productAttributeValue.product_attribute_value.name;
          productAttributeValueListEntry.product_attribute.value_index = parseInt(productAttributeValueIndex);
        }
      }

      if (removeProductAttributeValues) {
        delete(productAttributeValueListEntry.product_attribute.values);
        //	delete(productAttributeValueListEntry.product_attribute.value_index);
      }

      productAttributeValueList.push(productAttributeValueListEntry);
    }

    // check if we have to create lists for one or all attributes
    if (!productAttributeId) {
      for (var productAttributeId in dataCacheScoped.selected) {
        addProductAttributeValueToList(productAttributeId, removeProductAttributeValues);
      }
    } else {
      addProductAttributeValueToList(productAttributeId, removeProductAttributeValues);
    }

    return productAttributeValueList;
  }

  /**
   * Creates a data structure that contains a list of valid productAttributeValues with products for the combination of the
   * focused productAttributeValue and the rest of the selected attribute values
   * @param {String} productAttributeId The attributeId of the attribute we want to get a attributeValues list for
   * @param {String} productAttributeValue The value that is has been changed through a user interaction
   * @param {Object} [optional] selectedProductAttributes Normally the function gets the information about the currently selected attributes from the attributesInfo datastructure. With this param it can be overwritten
   * @return {Array} The results
   */
  function searchProductsForProductAttributeIdAndValue(productAttributeId, productAttributeValue, selectedProductAttributes) {
    var dataCacheScoped = dataCache.attributes,
      possibleProductAttributeValues = dataCacheScoped.available[productAttributeId].product_attribute.values,
      selectedProductAttributes = selectedProductAttributes ? selectedProductAttributes : dataCacheScoped.selected,
      foundProducts = [],
      loopCounter = 0,
      debugMessageType = 'attributeSearch for ' + products.parent.product['attribute_' + productAttributeId];

    timedDebugGroupStart(debugMessageType);

    // run through the possible values for the current productAttributeId to get a product that has one of the possible values
    // and as far as possible of the other current selected attribute values
    for (var possibleAttributeValueIndex = 0; possibleAttributeValueIndex < possibleProductAttributeValues.length; possibleAttributeValueIndex++) {
      var possibleAttributeValue = possibleProductAttributeValues[possibleAttributeValueIndex],
        bestProductCandidateMatchCounter = 0,
        bestProductCandidate = null,
        productsWithPossibleValue = [],
        completeProductAttributeSetFound = false;

      // get child products that have the current possible attribute value
      for (var childProductId in products.children) {
        var childProduct = products.children[childProductId];
        // run through the currently selected attribute values
        for (var selectedAttributeId in selectedProductAttributes) {
          var selectedAttribute = selectedProductAttributes[selectedAttributeId];

          if (selectedAttribute.product_attribute.id == productAttributeId &&
            childProduct.product['attribute_' + selectedAttribute.product_attribute.id] == possibleAttributeValue) {
            productsWithPossibleValue.push(childProduct);
          }
        }
      }

      // now search in the found child products for the other currently selected attribute values
      for (var possibleChildProductId in productsWithPossibleValue) {
        var possibleChildProduct = productsWithPossibleValue[possibleChildProductId],
          matchCounter = 1, //
          bestCandidateOrderable = false; // script should not only check the attributes but also check if the best candidate is orderable

        for (var selectedAttributeId in selectedProductAttributes) {
          // while on stepbystep mode we don't need to compare atts
          // lower than the ones we ask for
          if (_this.isStepByStepMode()) {
            if (selectedAttributeId > productAttributeId) {
              break;
            }
          }
          var selectedAttribute = selectedProductAttributes[selectedAttributeId];

          // check if we have matches for attribute ids and attribute values that deffer from the current possible value
          if (selectedAttribute.product_attribute.id != productAttributeId &&
            possibleChildProduct.product['attribute_' + selectedAttribute.product_attribute.id] == selectedAttribute.product_attribute.value) {
            matchCounter++;
          }
        }

        // if this child product matches more attributes than the last bestProductCandidate
        // we use the current looped product as new bestProductCandidate
        // if best found candidate is found but not orderable, we keep on looking for better one
        if (bestProductCandidate === null || matchCounter > bestProductCandidateMatchCounter || (!bestCandidateOrderable && matchCounter >= bestProductCandidateMatchCounter)) {
          bestProductCandidateMatchCounter = matchCounter;
          bestProductCandidate = possibleChildProduct;
          bestCandidateOrderable = checkOrderableStatus(possibleChildProduct);
        }

        // if we found a child product with a complete set of attributes we can break the loop
        // for stepbystep mode we don't need full set of attributes, just down to level we ask
        // otherwise it break everything in some specific cases
        if (_this.isStepByStepMode()) {
          completeProductAttributeSetFound = (matchCounter == productAttributeId);
        } else {
          completeProductAttributeSetFound = (matchCounter == dataCacheScoped.counters.parent[getParentProductId()].values);
        }

        if (completeProductAttributeSetFound && bestCandidateOrderable) {
          break;
        }

      }

      // collect some data about the product
      var foundProduct = {
        product_attribute_value: {
          product_attribute_name: dataCacheScoped.available[productAttributeId].product_attribute.name,
          product_attribute_id: productAttributeId,
          name: possibleAttributeValue,
          product: completeProductAttributeSetFound ? bestProductCandidate.product : options.allowProductSuggestions ? bestProductCandidate.product : null,
          product_id: completeProductAttributeSetFound ? parseInt(bestProductCandidate.product.id) : options.allowProductSuggestions ? parseInt(bestProductCandidate.product.id) : null,
          selectable: completeProductAttributeSetFound ? true : options.allowProductSuggestions ? true : false,
          selected: possibleAttributeValue == productAttributeValue,
          orderable: completeProductAttributeSetFound ? checkOrderableStatus(bestProductCandidate) : options.allowProductSuggestions ? checkOrderableStatus(bestProductCandidate) : false
        }
      };

      if (options.allowProductSuggestions) {
        foundProduct.product_attribute_value.is_product_suggestion = completeProductAttributeSetFound ? false : options.allowProductSuggestions ? true : false;
      }

      if (completeProductAttributeSetFound) {
        if (!productCanBeAddedToCart(bestProductCandidate)) {
          foundProduct.product_attribute_value.orderable = false;
        }
      }

      // remove unavailable products from the list if the right mode is activated
      if ((dataCache.productSelectionMode == productSelectionModes.INCOMPLETE_PRODUCTS_WITH_TWO_ATTRIBUTES || _this.isStepByStepMode()) && productAttributeId > 1 && !completeProductAttributeSetFound) {
        foundProduct = null;
      }

      if (foundProduct) {
        foundProducts.push(foundProduct);
      }
    }

    timedDebugGroupStop(debugMessageType);

    return foundProducts;
  }

  /**
   * Counts the attributes, attribute values and selected attribute values of a product
   */
  function checkAttributesSelectableStatus() {
    var product = getSelectedProduct();
    if (!isChildProduct(product)) {
      return false;
    }

    var attributeCounter = 0,
      attributeValueCounter = 0,
      attributeValueCounterSelectable = 0,
      attributes = createProductAttributes(product);

    for (var attributeIndex = 0; attributeIndex < attributes.length; attributeIndex++) {
      var attribute = attributes[attributeIndex];

      for (var attributeValueIndex = 0; attributeValueIndex < attribute.product_attribute.values.length; attributeValueIndex++) {
        var attributeValue = attribute.product_attribute.values[attributeValueIndex];

        if (attributeValue.selectable) {
          attributeValueCounterSelectable++;
        }
        attributeValueCounter++;
      }

      debugConsole.info("attribute: %s | %s values", attributeIndex + 1, attribute.product_attribute.values.length);

      attributeCounter++;
    }

    debugConsole.info("%s attributes | %s attribute values | %s selectable attribute values", attributeCounter, attributeValueCounter, attributeValueCounterSelectable);
  }

  /*********************************************
   * DATA ANALYSIS
   *********************************************/

  /**
   * Sets a status in a productInputField if it's data is valud
   * @param {Object} productInputField A productInputField
   * @return {Boolean} The status
   */
  function setProductInputFieldIsValidStatus(productInputField) {
    if ((productInputField.product_input_field.is_required && productInputField.product_input_field.value.trim().length > 0) || !productInputField.product_input_field.is_required) {
      productInputField.product_input_field.is_valid = true;
    } else {
      productInputField.product_input_field.is_valid = false;
    }

    return productInputField.product_input_field.is_valid;
  }

  /**
   * Sanitize a dataset before passing it to the UI
   * @param  {String} dataType The type of data (product, product_option, product_option_value, product_input_field)
   * @param  {Object} dataRow The data to be sanitized
   * @param  {Boolean} sanitizeValues Shall the data really be sanitized
   * @return {Object} The sanitized data
   */
  function sanitizeProductData(dataType, dataRow, sanitizeValues) {
    var validDataTypes = ['product', 'product_option', 'product_option_value', 'product_input_field'];
    if (validDataTypes.indexOf(dataType) === -1) {
      return false;
    }
    var mappingNumeric = {
      product: ['id', 'parent_id', 'stock_quantity', 'image_count'],
      product_option: ['id', 'order_index', 'product_id', 'value_id', 'value_index'],
      product_option_value: ['id', 'order_index', 'product_id', 'product_option_id'],
      product_input_field: ['id', 'order_index', 'product_id', 'type']
    };

    if (sanitizeValues && mappingNumeric[dataType]) {
      for (var dataKey in dataRow[dataType]) {
        for (var fieldIndex = 0; fieldIndex < mappingNumeric[dataType].length; fieldIndex++) {
          if (dataKey != mappingNumeric[dataType][fieldIndex]) {
            continue;
          }
          dataRow[dataType][dataKey] = dataRow[dataType][dataKey] ? parseInt(dataRow[dataType][dataKey]) : dataRow[dataType][dataKey];
        }
      }
    }

    return dataRow;
  }

  /**
   * Checks the selectedValues object for invalid data and cleans it if necessary
   */
  function sanitizeSelectedValues() {
    var tmpValues = {};

    if (selectedValues)
      tmpValues = selectedValues;

    if (tmpValues.product_id && !getProductByProductId(tmpValues.product_id)) {
      tmpValues = {};
      debugConsole.info('sanitizeSelectedValues: everything sanitized because of invalid product_id');
    } else if (tmpValues.product_id) {
      // check the input fields
      if (tmpValues.input_fields && Object.keys(tmpValues.input_fields).length > 0) {
        outerLoop: for (var productId in tmpValues.input_fields) {
          var selectedProductInputFields = tmpValues.input_fields[productId];

          for (var productInputFieldId in selectedProductInputFields) {
            var selectedProductInputField = selectedProductInputFields[productInputFieldId];

            // do three checks. if one of them fails we have invalid selectedValues data
            // 1: check if the current input field belongs to one of the current products
            // 2: default product: check if the input field belongs to the parent product
            // 3: parent with child products: the current input field belongs to a child product. check if this product is currently selected
            if ((!isProduct(getProductByProductId(productId)) || !productInputFieldBelongsToProduct(productId, productInputFieldId)) ||
              (!productHasChildProducts(getParentProduct()) && productId != tmpValues.product_id) ||
              (productHasChildProducts(getParentProduct()) && !isParentProduct(getProductByProductId(productId)) && productId != tmpValues.product_id)) {
              tmpValues.input_fields = {};
              debugConsole.info('sanitizeSelectedValues: inputs sanitized');
              break outerLoop;
            }
          }
        }
      }

      // check the options
      if (tmpValues.options && Object.keys(tmpValues.options).length > 0) {
        outerLoop: for (var productId in tmpValues.options) {
          var selectedProductOptions = tmpValues.options[productId];

          for (var productOptionId in selectedProductOptions) {
            var selectedProductOption = selectedProductOptions[productOptionId];

            // do three checks. if one of them fails we have invalid selectedValues data
            // 1: check if the current option belongs to one of the current products
            // 2: default product: check if the option belongs to the parent product
            // 3: parent with child products: the current option belongs to a child product. check if this product is currently selected
            if ((!isProduct(getProductByProductId(productId)) || !productOptionValueBelongsToProductOption(productId, productOptionId, selectedProductOption)) ||
              (!productHasChildProducts(getParentProduct()) && productId != tmpValues.product_id) ||
              (productHasChildProducts(getParentProduct()) && !isParentProduct(getProductByProductId(productId)) && productId != tmpValues.product_id)) {
              tmpValues.options = {};
              debugConsole.info('sanitizeSelectedValues: options sanitized');
              break outerLoop;
            }
          }
        }
      }
    }

    return tmpValues;
  }

  /**
   * Checks if all required product input fields are filled with valid data
   */
  function checkProductInputFieldRequiredStatus() {
    var selectedProductInputFields = selectedValues.input_fields;
    var productInputFieldRequiredCounter = 0;
    var relevantDataCache;
    // initialize a custom state for the input field validation plugin broadcasts
    if (typeof states.invalidInputFieldStateBroadcasted === 'undefined') {
      states.invalidInputFieldStateBroadcasted = false;
    }

    // check if there is anything to check at all
    if (dataCache.hasOwnProperty('input_fields')) {
      for (var productId in selectedProductInputFields) {
        if (!selectedProductInputFields[productId]) {
          continue;
        }

        for (var productInputFieldId in selectedProductInputFields[productId]) {
          if (!productInputFieldId) {
            continue;
          }

          relevantDataCache = isChildProduct(getProductByProductId(productId))
            ? dataCache.input_fields.children : dataCache.input_fields.parent;

          // check the stored data has a value,
          // since dataCache.parent / dataCache.children can be an empty object by initialization
          if (!relevantDataCache[productId]) {
            continue;
          }

          var productInputField
                = relevantDataCache[productId][productInputFieldId].product_input_field;

          if (productInputField.is_required && !productInputField.value.trim()) {
            productInputFieldRequiredCounter++;
            break;
          }
        }
      }
    }

    states.invalidInputFieldStateBroadcasted = !states.invalidInputFieldStateBroadcasted;

    checkUserChoiceIsDone(!!productInputFieldRequiredCounter);
  }

  /**
   * If change occurred, changes the add to cart button state
   * @param {boolean} cartButtonShouldBeLocked Indicates if required fields are invalid
   */
  function checkUserChoiceIsDone(cartButtonShouldBeLocked) {
    var isCartButtonLockedAlready = getState('cartButtonLocked');

    if (!cartButtonShouldBeLocked && isStepByStepMode()) {
      if (!_this.getState(_this.getProductSelectionStates().STATE_STEPBYSTEP_SELECTION_DONE)) {
        cartButtonShouldBeLocked = true;
      }
    }

    if (isCartButtonLockedAlready && cartButtonShouldBeLocked) {
      return;
    }

    setStateCartButtonLocked(cartButtonShouldBeLocked);
  }

  /**
   * Gets some information about the data fields of the products. This is necessary to decide if some
   * item data has to be requested from the server.
   */
  function checkProductFields() {
    timedDebugGroupStart('checkProductFields');

    // collect the needed information for the parent product
    var validProductCounter = 0,
      parentCheck = {
        field_counter: Object.keys(getParentProduct().product).length,
        acceptable_variation: null
      };

    dataCache.product_checks.parent = parentCheck;

    // collect some informations for the child products
    if (productHasChildProducts(getParentProduct())) {
      // compare the field counter of the parent to the field counter of the selected child product. this will have the complete data
      dataCache.product_checks.parent.acceptable_variation = Math.abs(parentCheck.field_counter - Object.keys(getSelectedProduct().product).length) + acceptableFieldCounterVariation;

      // count the complete child products
      for (var childProductId in products.children) {
        if (checkProductFieldsForChildProduct(products.children[childProductId])) {
          validProductCounter++;
        }
      }

      debugConsole.info("checkProductFields: %s of %s products have valid fields", validProductCounter, Object.keys(products.children).length);
    }

    timedDebugGroupStop('checkProductFields');
  }

  /**
   * Checks if a child product has a comlete list of fields
   * @param {Object} product The child product that has to be checked
   * @return {Boolean} TRUE if the field list is complete. FALSE if not.
   */
  function checkProductFieldsForChildProduct(product) {
    if (!isChildProduct(product)) {
      return false;
    }

    var productFieldsComplete = false;

    if (typeof product.product.extended_fields) {
      productFieldsComplete = product.product.extended_fields;
    }

    return productFieldsComplete;

    /*

     // collect the necessary data
     var relevantDataCache 		= dataCache.product_checks,
     productFieldCounter 	= Object.keys(product.product).length,
     fieldCounterVariation 	= relevantDataCache.parent.field_counter - productFieldCounter,
     productFieldsComplete 	= Math.abs(fieldCounterVariation) <= relevantDataCache.parent.acceptable_variation;

     relevantDataCache.children[product.product.id] = {
     field_counter: 	productFieldCounter,
     is_complete: 	productFieldsComplete
     };

     return productFieldsComplete;
     */
  }

  /*********************************************
   * AJAX STUFF
   *********************************************/

  function performAjaxRequest(options) {
    if (typeof $.shopgate.ajax == 'undefined') {
      debugConsole.error('No ajax helper found');
      return false;
    }

    var defaults = {
      beforeSend: function (jqXHR, settings) {},
      complete: function (jqXHR, textStatus) {},
      error: function (jqXHR, textStatus, errorThrown) {},
      success: function (data, textStatus, jqXHR) {}
    };

    options = $.extend({}, defaults, options);

    // prepare the ajax options
    var ajaxOptions = $.extend({}, options);

    ajaxOptions.beforeSend = function (jqXHR, settings) {
      options.beforeSend(jqXHR, settings);
    };

    ajaxOptions.complete = function (jqXHR, textStatus) {
      options.complete(jqXHR, textStatus);
    };

    ajaxOptions.error = function (jqXHR, textStatus, errorThrown) {
      options.error(jqXHR, textStatus, errorThrown);
    };

    ajaxOptions.success = function (data, textStatus, jqXHR) {
      options.success(data, textStatus, jqXHR);
    };

    // do the ajax request
    $.shopgate.ajax(ajaxOptions);
  }


  /*********************************************
   * STATES MANAGEMENT
   *********************************************/

  /**
   * Sets a specified state. The default value of every state is FALSE. If a state is set to TRUE by an extern caller
   * every caller has to reset the state till it will take back to FALSE. The function allowes to define custom states.
   * @param {String} type  The name of the state
   * @param {Boolean} value TRUE or FALSE. If this variable is not defined it will take TRUE as default.
   * @param {Boolean} ignoreCounter If set to TRUE the updateStates function will called everytime tha state changes. This flag can only be set for non core states
   */
  function setState(type, value, ignoreCounter = false) {
    // correct the value if is not defined
    if (typeof value != 'boolean') {
      value = true;
    }

    // init the states containers if this hasn't already been done
    if (!states.stateTypes) {
      states.stateTypes = {};
      states.stateCounters = {};
    }

    var performStateUpdate = false,
      currentStateForType = null;

    if (typeof states.stateTypes[type] == 'undefined') {
      // this is the first call for this state type. so we init all variables for it
      states.stateTypes[type] = value;
      states.stateCounters[type] = value === true ? 1 : 0;

      performStateUpdate = true;
    } else {
      // this state type has already been called. we temporarily save the old state for comparison
      currentStateForType = states.stateTypes[type];

      // the state value is TRUE so we increase the true counter.
      // on every TRUE call has to follow a FALSE call to reset the state to FALSE
      if (value === true) {
        states.stateCounters[type]++;
      } else if (states.stateCounters[type] > 0) {
        states.stateCounters[type]--;
      }

      if (ignoreCounter && coreStates.indexOf(type) == -1 && states.stateCounters[type] > 0) {
        states.stateCounters[type] = 1;
      }

      // check if the state can be reset to false
      states.stateTypes[type] = states.stateCounters[type] === 0 ? false : true;

      // the state type has changed. so we can possibly inform the plugins
      if (currentStateForType != states.stateTypes[type]) {
        performStateUpdate = true;
      }
    }

    // only inform the plugins if the core is already initialized. before initialization the plugins
    //  have the chance to define their own states without update callse
    if (pluginsInitialized && performStateUpdate) {
      updateStates();
    }
  }

  /**
   * Returns an object with the current states
   * @returns {Object} The states object
   */
  function getStates() {
    return clone(states.stateTypes);
  }

  /**
   * Returns value for selected state
   * @param name
   * @returns mixed (value or null if no state is set)
   */
  function getState(name) {
    var states = _this.getStates();
    if (states.hasOwnProperty(name)) {
      return states[name];
    } else {
      return null;
    }
  }

  /**
   * Informs the plugins to update their states
   */
  function updateStates() {
    _this.callPlugins('onUpdateStates', states.stateTypes);
  }

  /**
   * Sets the productUpdatePending state
   * @param {boolean} value [optional] The desired state. If left empty the state will be set to TRUE
   */
  function setStateProductUpdatePending(value) {
    setState('productUpdatePending', value);
  }

  /**
   * Sets the stockUpdatePending state
   * @param {boolean} value [optional] The desired state. If left empty the state will be set to TRUE
   */
  function setStateStockUpdatePending(value) {
    setState('stockUpdatePending', value);
  }

  /**
   * Sets the priceUpdatePending state
   * @param {boolean} value [optional] The desired state. If left empty the state will be set to TRUE
   */
  function setStatePriceUpdatePending(value) {
    setState('priceUpdatePending', value);
  }

  /**
   * Sets the cartButtonLocked state
   * @param {boolean} value [optional] The desired state. If left empty the state will be set to TRUE
   */
  function setStateCartButtonLocked(value) {
    var currentState = getState('cartButtonLocked');
    if ((currentState === null || !currentState) && !orderable) {
      value = true;
    } else if (currentState && !orderable) {
      return;
    }
    setState('cartButtonLocked', value);
  }

  /**
   * Sets the cartButtonBusy state
   * @param {boolean} value [optional] The desired state. If left empty the state will be set to TRUE
   */
  function setStateCartButtonBusy(value) {
    setState('cartButtonBusy', value);
  }

  /*********************************************
   * SORTING OF ATTRIBUTES, INPUT FIELDS AND OPTIONS
   *********************************************/

  /**
   * Sorts a list of productOptions - order_index by default
   * @param {Object} product The product for which we create the data
   * @param {Array} unorderedProductOptions A list of productOptions or productOptionValues
   * @return {Array} The sorted list of productOptions
   */
  function sortProductOptions(product, unorderedProductOptions) {
    return productOptionsSortHelper(product, unorderedProductOptions, false);
  }

  /**
   * Sorts a list of productOptionValues - order_index by default
   * @param {Object} product The product for which we create the data
   * @param {Object} productOption
   * @param {Array} unorderedProductOptionValues A list of productOptionValues
   * @return {Array} The sorted list of productOptionValues
   */
  function sortProductOptionValues(product, productOption, unorderedProductOptionValues) {
    return productOptionsSortHelper(product, unorderedProductOptionValues, true, productOption);
  }

  /**
   * Sorts a list of productOptions or productOptionValues - order_index by default
   * @param {Object} product The product for which we create the data
   * @param {Array} unorderedProductValues A list of productOptions or productOptionValues
   * @param {Boolean} isOptionValues Determines if the function should sort productOptionValues
   * @param {Object} [productOption]
   * @return {Array} The sorted list of productOptions or productOptionValues
   */
  function productOptionsSortHelper(product, unorderedProductValues, isOptionValues, productOption) {
    var pluginScope = isOptionValues ? plugins.sort.option_values : plugins.sort.options,
      productValueType = isOptionValues ? 'product_option_value' : 'product_option',
      messageType = isOptionValues ? 'sortProductOptionValues' : 'sortProductOptions',
      pluginFound = false,
      orderByOrderIndex = checkOrderIndices(unorderedProductValues, productValueType),
      suitableSortPlugins = [];

    timedDebugGroupStart(messageType);

    /**
     * Checks if we can use the orderIndex to sort the values. If every orderIndex has the same value we will order the values with a natural sort by name
     * @param  {Array} unorderedProductValues A list of productOptions or productOptionValues
     * @param  {String} productValueType      The type of the productValue - productOption or productOptionValue
     * @return {Boolean}                      TRUE if we can use the orderIndex, FALSE if not
     */
    function checkOrderIndices(unorderedProductValues, productValueType) {
      var currentOrderIndex = unorderedProductValues[0][productValueType].order_index;

      for (var productValueIndex = 0; productValueIndex < unorderedProductValues.length; productValueIndex++) {
        var productValue = unorderedProductValues[productValueIndex];

        if (productValue[productValueType].order_index != currentOrderIndex) {
          return true;
        }
      }

      return false;
    }

    // get a list of sort plugins that can be used in the current situation
    suitableSortPlugins = getSuitableSortPlugins(pluginScope, productValueType);

    if (suitableSortPlugins.length > 0) {
      for (var pluginIndex in suitableSortPlugins) {
        var sortPlugin = suitableSortPlugins[pluginIndex];

        if (isOptionValues) {
          if (isFunction(sortPlugin.onProductOptionValueSort)) {
            unorderedProductValues = sortPlugin.onProductOptionValueSort(unorderedProductValues, product, productOption, getSortShopProperties());
            debugConsole.info('Plugin "%s" used for productId "%s" and productOptionId "%s"', typeof sortPlugin.name == 'string' ? sortPlugin.name : 'UNNAMED', product.product.id, productOption.product_option.name);
          }
        } else {
          if (isFunction(sortPlugin.onProductOptionSort)) {
            unorderedProductValues = sortPlugin.onProductOptionSort(unorderedProductValues, product, getSortShopProperties());
            debugConsole.info('Plugin "%s" used for productId "%s"', typeof sortPlugin.name == 'string' ? sortPlugin.name : 'UNNAMED', product.product.id);
          }
        }
      }
    } else {
      if (orderByOrderIndex) {
        unorderedProductValues = unorderedProductValues.sort(function (a, b) {
          return b[productValueType].order_index - a[productValueType].order_index;
        });
      } else {
        var productValueNameList = [];

        // collect the names of the current productValue type
        for (var productValueIndex = 0; productValueIndex < unorderedProductValues.length; productValueIndex++) {
          var productValue = unorderedProductValues[productValueIndex];
          productValueNameList.push(productValue[productValueType].name);
        }

        // order them by natural sort
        productValueNameList.sort(naturalSort);

        var sortedUnorderedProductValues = [];

        // create the ordered list
        for (var productValueNameListEntryIndex = 0; productValueNameListEntryIndex < productValueNameList.length; productValueNameListEntryIndex++) {
          var productValueNameListEntry = productValueNameList[productValueNameListEntryIndex];

          for (var unorderedProductValuesEntryIndex = 0; unorderedProductValuesEntryIndex < unorderedProductValues.length; unorderedProductValuesEntryIndex++) {
            var unorderedProductValuesEntry = unorderedProductValues[unorderedProductValuesEntryIndex];

            if (unorderedProductValuesEntry[productValueType].name == productValueNameListEntry) {
              sortedUnorderedProductValues.push(unorderedProductValuesEntry);
            }
          }
        }

        unorderedProductValues = sortedUnorderedProductValues;
      }

      debugConsole.info('%s: Plugin "DEFAULT" used for productId "%s"', messageType, product.product.id);
    }

    timedDebugGroupStop(messageType);

    return unorderedProductValues;
  }

  /**
   * Sorts a list of input fields - order_index by default
   * @param {Array} unorderedProductInputFields A list of productInputFields
   * @param {Object} product The product for which we create the data
   * @return {Array} The sorted list of input fields
   */
  function sortProductInputFields(product, unorderedProductInputFields) {
    var pluginScope = plugins.sort.inputs,
      pluginFound = false,
      messageType = 'sortProductInputFields',
      orderByOrderIndex = checkOrderIndices(unorderedProductInputFields),
      suitableSortPlugins = [];

    timedDebugGroupStart(messageType);

    /**
     * Checks if we can use the orderIndex to sort the productInputFields. If every orderIndex has the same value we will order the productInputFields with a natural sort by name
     * @param  {Array} unorderedProductInputFields A list of productInputFields
     * @return {Boolean} TRUE if we can use the orderIndex, FALSE if not
     */
    function checkOrderIndices(unorderedProductInputFields) {
      var currentOrderIndex = unorderedProductInputFields[0].product_input_field.order_index;

      for (var productInputFieldIndex = 0; productInputFieldIndex < unorderedProductInputFields.length; productInputFieldIndex++) {
        var productInputField = unorderedProductInputFields[productInputFieldIndex];

        if (productInputField.product_input_field.order_index != currentOrderIndex) {
          return true;
        }
      }

      return false;
    }

    function callProductInputFieldsPlugin(productInputFieldsSortPlugin) {
      unorderedProductInputFields = productInputFieldsSortPlugin.onProductInputFieldSort(unorderedProductInputFields, product, getSortShopProperties());
      debugConsole.info('Plugin "%s" used for productId "%s"', typeof productInputFieldsSortPlugin.name == 'string' ? productInputFieldsSortPlugin.name : 'UNNAMED', product.product.id);
    }

    // get a list of sort plugins that can be used in the current situation
    suitableSortPlugins = getSuitableSortPlugins(pluginScope, 'product_input_field');

    if (suitableSortPlugins.length > 0) {
      for (var pluginIndex in suitableSortPlugins) {
        var sortPlugin = suitableSortPlugins[pluginIndex];
        if (isFunction(sortPlugin.onProductInputFieldSort)) {
          callProductInputFieldsPlugin(sortPlugin);
        }
      }
    } else {
      if (orderByOrderIndex) {
        unorderedProductInputFields = unorderedProductInputFields.sort(function (a, b) {
          return b.product_input_field.order_index - a.product_input_field.order_index;
        });
      } else {
        var productInputFieldNameList = [];

        // collect the names of the current productInputFields
        for (var productInputFieldIndex = 0; productInputFieldIndex < unorderedProductInputFields.length; productInputFieldIndex++) {
          var productInputField = unorderedProductInputFields[productInputFieldIndex];
          productInputFieldNameList.push(productInputField.product_input_field.label);
        }

        // order them by natural sort
        productInputFieldNameList.sort(naturalSort);

        var sortedUnorderedProductInputFields = [];

        // create the ordered list
        for (var productInputFieldNameListEntryIndex = 0; productInputFieldNameListEntryIndex < productInputFieldNameList.length; productInputFieldNameListEntryIndex++) {
          var productInputFieldNameListEntry = productInputFieldNameList[productInputFieldNameListEntryIndex];

          for (var unorderedProductInputFieldEntryIndex = 0; unorderedProductInputFieldEntryIndex < unorderedProductInputFields.length; unorderedProductInputFieldEntryIndex++) {
            var unorderedProductInputFieldEntry = unorderedProductInputFields[unorderedProductInputFieldEntryIndex];

            if (unorderedProductInputFieldEntry.product_input_field.label == productInputFieldNameListEntry) {
              sortedUnorderedProductInputFields.push(unorderedProductInputFieldEntry);
            }
          }
        }

        unorderedProductInputFields = sortedUnorderedProductInputFields;
      }

      debugConsole.info('Plugin "DEFAULT" used for productId "%s"', product.product.id);
    }

    timedDebugGroupStop(messageType);

    return unorderedProductInputFields;
  }

  /**
   * Returns a list of suitable sort plugins for the current situation.
   * @param  {Array} sortPluginScope The list of sort plugins for the current scope
   * @param  {String} sortPluginScopeType The type of the current scopr
   * @param  {String} productAttributeName [optional] The name of the attribute for the productAttributeSort
   * @return {Array} The list or an empty array
   */
  function getSuitableSortPlugins(sortPluginScope, sortPluginScopeType, productAttributeName) {
    var validDataTypes = ['product_option', 'product_option_value', 'product_input_field', 'product_attribute'],
      sortFunctionMapping = {
        product_attribute: 'onProductAttributeSort',
        product_option: 'onProductOptionSort',
        product_option_value: 'onProductOptionValueSort',
        product_input_field: 'onProductInputFieldSort'
      },
      haystacks = [],
      suitableSortPlugins = [],
      suitableSortPluginsIndices = [];

    if (validDataTypes.indexOf(sortPluginScopeType) === -1) {
      return false;
    }

    timedDebugGroupStart('getSuitableSortPlugins');

    function searchSortPlugin(haystack, needle) {
      for (var sortPluginIndex = 0; sortPluginIndex < sortPluginScope.length; sortPluginIndex++) {
        var sortPlugin = sortPluginScope[sortPluginIndex];

        // check if the plugin has a valid callback function - skip this plugin
        if (typeof sortPlugin[sortFunctionMapping[sortPluginScopeType]] !== 'function') {
          continue;
        }
        // check if the plugin is already in the result array - skip this plugin
        if (suitableSortPluginsIndices.indexOf(sortPluginIndex) !== -1) {
          continue;
        }

        // check if we can find a needle in the current haystack
        if (haystack) {
          if (!needle) {
            continue;
          }
          if (typeof needle.toLowerCase == 'function') {
            needle = needle.toLowerCase();
          }
          if (Array.isArray(sortPlugin[haystack]) && sortPlugin[haystack].indexOf(needle) !== -1) {
            suitableSortPlugins.push(sortPlugin);
            suitableSortPluginsIndices.push(sortPluginIndex);
            break;
          }
        } else {
          suitableSortPlugins.push(sortPlugin);
          suitableSortPluginsIndices.push(sortPluginIndex);
        }
      }
    }

    // only run the search if there are plugins in the current plugin scope
    if (Array.isArray(sortPluginScope) && sortPluginScope.length > 0) {
      // prepare the haystacks
      haystacks.push({
        haystack: 'shop_numbers',
        needle: getShopNumber()
      });
      haystacks.push({
        haystack: 'shop_groups',
        needle: getShopGroup()
      });

      if (sortPluginScopeType == 'product_attribute' && productAttributeName) {
        haystacks.push({
          haystack: 'product_attribute_names',
          needle: productAttributeName
        });
      }

      // search based on the haystacks
      for (var haystackIndex = 0; haystackIndex < haystacks.length; haystackIndex++) {
        var haystack = haystacks[haystackIndex];
        searchSortPlugin(haystack.haystack, haystack.needle);
      }
    }

    timedDebugGroupStop('getSuitableSortPlugins');

    return suitableSortPlugins;
  }

  /**
   * Sorts a ProductAttributeList. If possible an AttributeSortPlugin will be used
   * @param {String} 	productAttributeName A parent product attribute name
   * @param {Array} 	productAttributeValues A list of ChildProduct attribute values
   * @return {Array} 	The sorted list of product attributes
   */
  function sortProductAttributeValuesList(productAttributeName, productAttributeValues) {
    var pluginScope = plugins.sort.attributes,
      suitableSortPlugins = null,
      selectedSortPlugin = null,
      sortedProductAttributeValues = [];

    timedDebugGroupStart('sortProductAttributeValuesList');

    suitableSortPlugins = getSuitableSortPlugins(pluginScope, 'product_attribute', productAttributeName);

    if (suitableSortPlugins.length > 0) {
      selectedSortPlugin = suitableSortPlugins[0];
    }

    if (selectedSortPlugin && isFunction(selectedSortPlugin.onProductAttributeSort)) {
      debugConsole.info('Plugin "%s" used for name "%s"', typeof selectedSortPlugin.name == 'string' ? selectedSortPlugin.name : 'UNNAMED', productAttributeName);
      sortedProductAttributeValues = selectedSortPlugin.onProductAttributeSort(productAttributeName, productAttributeValues, getSortShopProperties());
    } else if (isFunction(naturalSort)) {
      debugConsole.info('Plugin "%s" used for name "%s"', 'Default', productAttributeName);
      sortedProductAttributeValues = productAttributeValues.sort(naturalSort);
    } else {
      debugConsole.info('Plugin "%s" used for name "%s"', '-NULL-', productAttributeName);
      sortedProductAttributeValues = productAttributeValues;
    }

    timedDebugGroupStop('sortProductAttributeValuesList');

    // return the sorted list
    return sortedProductAttributeValues;
  }

  function getSortShopProperties() {
    return {
      shopNumber: getShopNumber(),
      shopGroup: getShopGroup()
    };
  }

  /**
   * Registers a new plugin
   * @param {Function} newPlugin
   * @return {Mixed} Plugin instance or FALSE on error
   */
  _this.registerPlugin = function (newPlugin) {
    var validPluginTypes = ['sort.attributes', 'sort.inputs', 'sort.options', 'sort.option_values', 'products.ui', 'products.data'],
      plugin = null,
      pluginName = 'unknown',
      pluginTypes = [];

    if (!newPlugin || typeof newPlugin !== 'function') {
      debugConsole.error('registerPlugin: no plugin passed');
      return false;
    }

    // it seems that we have a valid plugin. so we create an instance of it
    plugin = new newPlugin(_this, options);

    if (typeof plugin.name == 'string') {
      pluginName = plugin.name;
    }

    // extract the types of the plugin
    if (typeof plugin.type != 'undefined') {
      if (typeof plugin.type == 'string') {
        pluginTypes.push(plugin.type);
      } else if (Array.isArray(plugin.type)) {
        pluginTypes = plugin.type;
      }
    }

    if (pluginTypes.length === 0) {
      debugConsole.error('registerPlugin: The plugin "%s" provides no types', pluginName);
      return false;
    }

    // convert product_attribute_names to lowercase
    if (Array.isArray(plugin.product_attribute_names)) {
      plugin.product_attribute_names = plugin.product_attribute_names.map(function (value) {
        return value.toLowerCase();
      });
    }

    // register the plugin for the different plugin types. One plugin can support more than one type
    // so we register them within a loop
    for (var typeIndex = 0; typeIndex < pluginTypes.length; typeIndex++) {
      if (validPluginTypes.indexOf(pluginTypes[typeIndex]) != -1) {
        registerPlugin(plugin, pluginTypes[typeIndex]);
      } else {
        console.warn('registerPlugin: Plugin: "%s" | "%s" is not a valid plugin type. Valid types are: %s', pluginName, pluginTypes[typeIndex], validPluginTypes.join());
      }
    }

    return plugin;
  };

  /**
   * Registers a new plugin
   * @param {Object} plugin The plugin
   * @param {String} type The type of the plugin
   * @return {Mixed} FALSE on error
   */
  function registerPlugin(plugin, type) {
    var typeSegments = type.split('.'),
      target = null;

    if (typeSegments.length == 2 && plugins[typeSegments[0]] && plugins[typeSegments[0]][typeSegments[1]]) {
      target = plugins[typeSegments[0]][typeSegments[1]];
    }

    if (target) {
      target.push(plugin);
    }
  }

  /**
   * Prints a list of available Plugins
   */
  _this.getPluginInfo = function () {
    for (var pluginTypeIndex in plugins) {
      var pluginType = plugins[pluginTypeIndex];
      if (!Array.isArray(pluginType)) {
        for (var pluginSubtypeIndex in pluginType) {
          var pluginSubtype = pluginType[pluginSubtypeIndex];

          if (Array.isArray(pluginSubtype)) {
            for (var i = 0; i < pluginSubtype.length; i++) {
              var plugin = pluginSubtype[i],
                name = typeof plugin.name == 'string' ? plugin.name : 'unnamed',
                keys = Array.isArray(plugin.product_attribute_names) ? plugin.product_attribute_names.join() : 'not defined';

              console.info("%s | %s | Index: %s | Name: %s | Keys: %s", pluginTypeIndex, pluginSubtypeIndex, i, name, keys);
            }
          }
        }
      }
    }
  };

  _this.getDataCache = function () {
    return $.extend({}, dataCache);
  };

  _this.getSelectedValues = function (skipConsoleOutput) {
    if (typeof skipConsoleOutput == 'undefined' || skipConsoleOutput == false) {
      console.info('The current selected values');
      // clone this objects to prevent manipulations
      console.log(JSON.stringify(selectedValues));
    }

    return clone(selectedValues);
  };

  /*********************************************
   * PRODUCT RELATED HELPER FUNCTIONS
   *********************************************/

  function getSelectedProduct() {
    if (selectedValues.product_id) {
      if (products && products.parent && products.parent.product.id == selectedValues.product_id) {
        return products.parent;
      } else if (products && products.children && products.children[selectedValues.product_id]) {
        return products.children[selectedValues.product_id];
      }
    }

    return false;
  }

  function getProductByProductId(productId) {
    if (products && products.parent && getParentProductId() == productId) {
      return products.parent;
    } else if (products && products.children && products.children[productId]) {
      return products.children[productId];
    } else {
      return false;
    }
  }

  /**
   * Finds and returns product by given identifier.
   * Identifier is not ID, nor product_number.
   *
   * @param productIdentifier
   * @returns {*}
   */
  function getProductByProductIdentifier(productIdentifier) {
    if (products) {
      if (products.parent && $.sgHelpers.bin2hex(products.parent.product.product_number) === productIdentifier) {
        return products.parent;
      }
      if (products.children) {
        for (var childId in products.children) {
          if ($.sgHelpers.bin2hex(products.children[childId].product.product_number) === productIdentifier) {
            return products.children[childId];
          }
        }
      }
    }

    return null;
  }

  /**
   * Returns products object.
   *
   * @returns {*}
   */
  function getProducts() {
    return products;
  }

  function getParentProduct() {
    return products.parent;
  }

  function getParentProductId() {
    return parseInt(getProductId(products.parent), 10);
  }

  function getProductId(product) {
    if (!isProduct(product)) {
      return false;
    }
    return product.product.id;
  }


  function getSelectedProductOptionValues(specificProductOptionId) {
    var relevantData = selectedValues && selectedValues.options && Object.keys(selectedValues.options).length > 0 ? selectedValues.options : null,
      selectedOptionValues = {};

    if (!relevantData) {
      return null;
    }

    for (var productId in relevantData) {
      var product = getProductByProductId(productId),
        productOptionInfo = relevantData[productId];

      if (productHasOptions(product)) {
        for (var productOptionId in productOptionInfo) {
          var productOptionValueId = productOptionInfo[productOptionId];

          selectedOptionValues[productOptionId] = product.product.options[productOptionId].product_option.values[productOptionValueId];
        }
      }
    }

    if (specificProductOptionId) {
      return typeof selectedOptionValues[specificProductOptionId] != 'undefined' ? selectedOptionValues[specificProductOptionId] : null;
    } else {
      return Object.keys(selectedOptionValues).length > 0 ? selectedOptionValues : null;
    }
  }

  function getSelectedProductInputFields() {
    var relevantData = selectedValues && selectedValues.input_fields && Object.keys(selectedValues.input_fields).length > 0 ? selectedValues.input_fields : null,
      selectedInputFields = {};

    if (!relevantData) {
      return null;
    }

    for (var productId in relevantData) {
      var product = getProductByProductId(productId),
        productInputFieldInfo = relevantData[productId];

      if (productHasInputFields(product)) {
        for (var productInputFieldId in productInputFieldInfo) {
          selectedInputFields[productInputFieldId] = product.product.input_fields[productInputFieldId];
        }
      }
    }

    return Object.keys(selectedInputFields).length > 0 ? selectedInputFields : null;
  }

  /**
   * Chooses preselected product.
   * If product has children, chooses first children in a row,
   * which is also the cheapest one (most of the time, not if
   * stepbystep mode is disabled AND is special shop).
   *
   * If no children, the parent product is chosen
   *
   * @returns {Object|null} The preselected product, or NULL if nothing was found
   */
  function getPreselectedChildProduct() {
    var preselectedProduct = null;

    for (var productId in products.children) {
      if (products.children.hasOwnProperty(productId)) {
        var currentProduct = products.children[productId].product;

        if (currentProduct.extended_fields) {
          preselectedProduct = currentProduct;
          break;
        }
      }
    }

    // if no preselected product was found within the child products
    // we fall back to the current product variable
    if (preselectedProduct === null && isProduct(productsComplete.current_product)) {
      preselectedProduct = productsComplete.current_product.product;
    }

    return preselectedProduct;
  }

  function isProduct(product) {
    return (typeof product === 'object' && product && !Array.isArray(product) && typeof product.product !== 'undefined'); // typeof null === 'object'
  }

  function isParentProduct(product) {
    if (!isProduct(product)) {
      return false;
    }
    return !product.product.parent_id && product.product.has_children;
  }

  function isChildProduct(product) {
    if (!isProduct(product)) {
      return false;
    }
    return product.product.parent_id ? true : false;
  }

  function isProductOption(productOption) {
    return typeof productOption != 'undefined' && typeof productOption.product_option != 'undefined';
  }

  function isProductOptionValue(productOptionValue) {
    return typeof productOptionValue != 'undefined' && typeof productOptionValue.product_option_value != 'undefined';
  }

  function hasPriceInfo(value) {
    if (!isUndefined(value)) {
      if (!isUndefined(value.product)) {
        return actualCheck(value.product);
      } else if (!isUndefined(value.product_option)) {
        return actualCheck(value.product_option);
      } else if (!isUndefined(value.product_option_value)) {
        return actualCheck(value.product_option_value);
      } else if (!isUndefined(value.product_input_field)) {
        return actualCheck(value.product_input_field);
      }
    }

    return false;

    function actualCheck(value) {
      return typeof value.price_info != 'undefined';
    }
  }

  function productInputFieldBelongsToProduct(productId, productInputFieldId) {
    var product = getProductByProductId(productId);
    return product && productHasInputFields(product) && product.product.input_fields[productInputFieldId] ? true : false;
  }

  function productOptionBelongsToProduct(productId, productOptionId) {
    var product = getProductByProductId(productId);
    return product && productHasOptions(product) && product.product.options[productOptionId] ? true : false;
  }

  function productOptionValueBelongsToProductOption(productId, productOptionId, productOptionValueId) {
    var product = getProductByProductId(productId),
      productOptionValid = productOptionBelongsToProduct(productId, productOptionId);
    return product && productOptionValid && product.product.options[productOptionId].product_option.values[productOptionValueId];
  }

  function productHasChildProducts(product) {
    if (!isProduct(product)) {
      return false;
    }
    return !product.product.parent_id && product.product.has_children && products.children && Object.keys(products.children).length > 0 ? true : false;
  }

  function productHasOptions(product) {
    if (!isProduct(product)) {
      return false;
    }
    return !product.product.has_options || typeof product.product.options == 'undefined' ? false : true;
  }

  function productHasInputFields(product) {
    if (!isProduct(product)) {
      return false;
    }
    return !product.product.has_input_fields || typeof product.product.input_fields == 'undefined' ? false : true;
  }

  function productHasProductExtensionElements(dataType, product) {
    var validDataTypes = ['options', 'input_fields'];
    if (validDataTypes.indexOf(dataType) === -1) {
      return false;
    }
    if (!isProduct(product)) {
      return false;
    }

    return dataType == 'options' ? productHasOptions(product) : productHasInputFields(product);
  }

  function parentProductHasChildProducts() {
    return productHasChildProducts(getParentProduct());
  }

  function getShopId() {
    var shopId = null,
      parentProduct = getParentProduct();

    if (parentProduct.product.shop_id) {
      shopId = parentProduct.product.shop_id;
    } else if (productHasChildProducts(parentProduct)) {
      for (var childProductId in products.children) {
        var childProduct = products.children[childProductId];

        if (childProduct.product.shop_id) {
          shopId = childProduct.product.shop_id;
          break;
        }
      }
    }

    return isNumeric(shopId) ? parseInt(shopId) : shopId;
  }

  function getShopNumber() {
    return isNumeric(options.shopNumber) ? parseInt(options.shopNumber) : null;
  }

  function getShopGroup() {
    return options.shopGroup ? options.shopGroup : null;
  }

  function getCoreOptions() {
    return clone(options);
  }

  function isComponentActive(componentName) {
    if (!componentName) {
      return false;
    }
    return activeComponents && activeComponents[componentName] ? true : false;
  }

  function getComponentUrls(componentName) {
    if (!componentName || !isComponentActive(componentName)) {
      return null;
    }
    return activeComponents[componentName].urls && Object.keys(activeComponents[componentName].urls).length > 0 ? activeComponents[componentName].urls : null;
  }

  function getComponentVars(componentName) {
    if (!componentName || !isComponentActive(componentName)) {
      return null;
    }
    return activeComponents[componentName].vars && Object.keys(activeComponents[componentName].vars).length > 0 ? activeComponents[componentName].vars : null;
  }

  /**
   * Prepares the data for the share function based on the current selected product
   * @returns {Object} The generated data
   */
  function getShareDataForCurrentSelectedProduct() {
    const selectedProduct = getSelectedProduct();
    const shareData = {
      title: selectedProduct.product.name,
      deeplink: selectedProduct.product.deeplink_onlineshop,
      imageUrl: selectedProduct.product.image_urls[0]['image_url_150']
    };

    // If the selected product is a child product and doesn't contain a deeplink,
    // the deeplink of the parent product is used for the share link
    if (!shareData.deeplink && isChildProduct(selectedProduct)) {
      const parentProduct = getParentProduct();

      shareData.deeplink = parentProduct.product.deeplink_onlineshop;
    }

    if (shareData.deeplink) {
      // Remove shopgate internal parameters from the url
      const parsed = new SGLink(shareData.deeplink);

      parsed.deleteParam('mobile');
      parsed.deleteParam('shopgate_redirect');
      parsed.deleteParam('no_mobile_theme');

      shareData.deeplink = parsed.toString();
    }

    return shareData;
  }

  /**
   * Clones an object
   * @param  {Object} object The object that shall be cloned
   * @return {Object} The cloned object
   */
  function clone(object) {
    if (object === null || typeof (object) != 'object') {
      return object;
    }

    var temp = object.constructor();

    for (var key in object) {
      temp[key] = clone(object[key]);
    }

    return temp;
  }

  function isInitialized() {
    return coreInitialized;
  }

  function isUndefined(value) {
    return typeof value == 'undefined';
  }

  /**
   * Checks if a passed variable is a function
   * @param {Function} value The value to be checked
   * @return {Boolean}
   */
  function isFunction(value) {
    return typeof value == 'function';
  }

  /**
   * Checks if a passed variable is a string
   * @param {String} value The value to be checked
   * @return {Boolean}
   */
  function isString(value) {
    return typeof value == 'string';
  }

  function isArray(object) {
    return Array.isArray(object);
  }

  function isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  function isInteger(value) {
    return isNumeric(value) && value % 1 === 0;
  }

  function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function getGUID() {
    if (options.guid) {} else if (createGUID == 'function') {
      options.guid = createGUID();
    } else {
      options.guid = Date.now();
    }

    return options.guid;
  }


  /**
   * Iterates products and gets all possible attributes groupoed by identifier (attribute_XX).
   * The data includes the sorted attributes values and their (most) relevant product (productId).
   *
   * @param {object} products E.g. child items with attribute fields mapped to their ids
   * @returns {{}} Returns by id, eg:
   * {
   * 	attribute_1: [{attributeValue: "Black", productId: 123}, {attributeValue: "Pink", productId:124}],
   * 	attribute_2: [{attributeValue: "XS", productId: 123}, {attributeValue: "S", productId:124}]
   * 	}
   */
  function getAllAttributesGroupedByAttributeId(products) {
    var attributesById = {},
      attributeMapping = {};

    // collect all the attributes and the relevant products
    for (var productId in products) {
      var productIsOrderable = productCanBeAddedToCart(products[productId]);
      for (var attributeLevel = 1; products[productId].product.hasOwnProperty('attribute_' + attributeLevel); attributeLevel++) {
        var attributeId = 'attribute_' + attributeLevel,
          attr = products[productId].product[attributeId],
          assignProductToAttribute = false,
          attributeIsOrderable;
        if (attr.length) {
          attributeIsOrderable = isAttributeOrderable(attributeLevel, attr);
          // create entry
          if (!attributeMapping.hasOwnProperty(attributeId)) {
            attributeMapping[attributeId] = {};
          }

          if (typeof attributeMapping[attributeId][attr] === 'undefined') {
            // if there is no product ID in the same index as attribute index, we assign the current product to it
            assignProductToAttribute = true;
          } else {
            /* however, when it's already assigned, we check if the current product is cheaper than the one we already stored.
             * note from carina: no one is 100% sure about the edge case why we need the cheapest product,
             * but it may be because of the "from"-prices (ask szymon n. if you have any questions)
             */
            var existingAssignationPrice = products[attributeMapping[attributeId][attr]].product.price_info.unit_amount_display,
              candidateForAssignationPrice = products[productId].product.price_info.unit_amount_display;

            if (existingAssignationPrice > candidateForAssignationPrice) {
              assignProductToAttribute = true;
            }
          }

          if (assignProductToAttribute && (productIsOrderable || !attributeIsOrderable)) {
            attributeMapping[attributeId][attr] = productId;
          }
        }
      }
    }

    // sort the attributes
    for (var attributeId in attributeMapping) {
      var attributeValues = Object.keys(attributeMapping[attributeId]), // or polyfill
        sortedValues = sortProductAttributeValuesList(_this.products.parent.product[attributeId], attributeValues);
      attributesById[attributeId] = [];

      // interate the sorted attributes and create return-object with correct sort order
      for (var index in sortedValues) {
        var value = sortedValues[index];

        attributesById[attributeId].push({
          attributeValue: value,
          productId: attributeMapping[attributeId][value]
        });
      }
    }

    return attributesById;
  }

  function isAttributeOrderable(attributeId, attributeName) {
    if (!_this.products.children) {
      return null;
    }

    // Validate attributeName
    if (typeof attributeName !== 'string') {
      return false;
    }

    for (var childId in _this.products.children) {
      var childAttribute = _this.products.children[childId].product['attribute_' + attributeId];

      // Validate childAttribute
      if (typeof childAttribute !== 'string' || !childAttribute.length) {
        continue;
      }

      // Sanitize strings before comparing them because attributeName might be sanitized in stepbystep plugin before
      childAttribute = $.shopgate.decodeHTMLEntities($.trim(childAttribute));
      attributeName = $.shopgate.decodeHTMLEntities($.trim(attributeName));

      if (childAttribute == attributeName) {
        if (productCanBeAddedToCart(_this.products.children[childId])) {
          return true;
        }
      }
    }

    return false;
  }

  /**
   * Checks if CTA button should be disabled or not.
   * The logic behind:
   * - CTA should only be disabled if product is not for sale, or products' data is updated
   *
   * @returns {boolean}
   */
  function isAddToCartButtonDisabled() {
    var addToCartShouldBeLocked = false,
      statesValidIfTrue = ['productUpdatePending', 'stockUpdatePending', 'priceUpdatePending', 'cartButtonBusy'];

    for (var i in statesValidIfTrue) {
      if (states.stateTypes.hasOwnProperty(statesValidIfTrue[i]) && states.stateTypes[statesValidIfTrue[i]]) {
        addToCartShouldBeLocked = true;
        break;
      }
    }

    var isGroupedProduct = products.parent.product.display_type == _this.DISPLAY_TYPE_LIST;

    // If for grouped product no child is selected disable cart-button
    if (!addToCartShouldBeLocked && isGroupedProduct && !shopSettings.productDisplayListWithCta) {
      var numSelectedChildren = selectedValues.children ? Object.keys(selectedValues.children).length : 0;
      addToCartShouldBeLocked = numSelectedChildren == 0;
    }

    // If the parent product is selected and the step by step selection wasn't finished yet,
    // the productCanBeAddedToCart check shouldn't be executed, since parent products can't be
    // added to cart
    const stepByStepInProgress = _this.isStepByStepMode() &&
      options.showParentProductBeforeStepByStepIsDone &&
      isParentProduct(getSelectedProduct()) &&
      !_this.getState(_this.getProductSelectionStates().STATE_STEPBYSTEP_SELECTION_DONE);

    // For grouped products the selected product is always the parent. The parent might have
    // ignore_stock:false and stock_quantity:0 but the children are orderable
    if (!addToCartShouldBeLocked && !isGroupedProduct && !stepByStepInProgress) {
      addToCartShouldBeLocked = !productCanBeAddedToCart(getSelectedProduct());
    }

    return addToCartShouldBeLocked;
  }

  /*********************************************
   * PROPAGATE SOME BASIC HELPER FUNCTIONS FOR PLUGINS
   *********************************************/
  _this.isProduct = isProduct;
  _this.getProducts = getProducts;
  _this.getParentProduct = getParentProduct;
  _this.getParentProductId = getParentProductId;
  _this.setProductId = setProductId;
  _this.getProductByProductId = getProductByProductId;
  _this.getProductByProductIdentifier = getProductByProductIdentifier;
  _this.getSelectedProduct = getSelectedProduct;
  _this.getPreselectedChildProduct = getPreselectedChildProduct;
  _this.getAllAttributesGroupedByAttributeId = getAllAttributesGroupedByAttributeId;
  _this.isChildProduct = isChildProduct;
  _this.productHasChildProducts = productHasChildProducts;
  _this.productHasOptions = productHasOptions;
  _this.productCanBeAddedToCart = productCanBeAddedToCart;
  _this.productHasInputFields = productHasInputFields;
  _this.parentProductHasChildProducts = parentProductHasChildProducts;
  _this.isAttributeOrderable = isAttributeOrderable;
  _this.getShareDataForCurrentSelectedProduct = getShareDataForCurrentSelectedProduct;
  _this.isAddToCartButtonDisabled = isAddToCartButtonDisabled;

  _this.getShopId = getShopId;
  _this.getCoreOptions = getCoreOptions;
  _this.isComponentActive = isComponentActive;
  _this.getComponentUrls = getComponentUrls;
  _this.getComponentVars = getComponentVars;

  _this.clone = clone;
  _this.isString = isString;
  _this.isFunction = isFunction;
  _this.isArray = isArray;
  _this.isNumeric = isNumeric;
  _this.getRandomInt = getRandomInt;

  _this.products = products;

  // public getters
  _this.getProductSelectionModes = getProductSelectionsModes;
  _this.getProductSelectionStates = getProductSelectionStates;

  _this.isStepByStepMode = isStepByStepMode;

  _this.getBlockPricingGroupForQuantity = getBlockPricingGroupForQuantity;

  _this.calculatePriceInfo = calculatePriceInfo;

  /**
   * Calls the plugins and passes some data
   * @param {String} method The name of the called plugin method
   * @param  {Object} data The passed data
   */
  _this.callPlugins = function (method, data) {
    if (!data) data = {};
    for (var i = 0; i < plugins.products.data.length; i++) {
      if (method in plugins.products.data[i]) {
        if (isPluginEnabled(getPluginName(plugins.products.data[i]), method)) {
          plugins.products.data[i][method]('products.data', data);
        }
      }
    }

    for (var i = 0; i < plugins.products.ui.length; i++) {
      if (method in plugins.products.ui[i]) {
        if (isPluginEnabled(getPluginName(plugins.products.data[i]), method)) {
          plugins.products.ui[i][method]('products.ui', data);
        }
      }
    }
  };

  /**
   * Returns the name of passed core plugin
   * @param {object} plugin A product details core plugin
   * @returns {string} The name of the plugin if present or an empty string
   */
  function getPluginName(plugin) {
    return plugin && plugin.name ? plugin.name : '';
  }

  /**
   * Checks if a core plugin is enabled
   * @param {string} pluginName The name of the plugin that has to be checked
   * @return {boolean}
   */
  function isPluginEnabled(pluginName, currentMethod) {
    var isEnabled = true;
    // check if the core options contain a disabled flag for the current plugin name
    if (options.plugins &&
      options.plugins[pluginName] &&
      options.plugins[pluginName].disabled !== undefined) {
      // evaluate the flag
      isEnabled = !options.plugins[pluginName].disabled;

      // reenable the plugin for the onStatusUpdate if this method is allowed
      if (!isEnabled && currentMethod == 'onStatusUpdate' && plugins[pluginName].alwaysAllowStatusUpdate) {
        isEnabled = true;
      }
    }

    if (!isEnabled) {
      debugConsole.info("Core plugin %s is DISABLED", pluginName);
    }

    return isEnabled;
  }

  /*********************************************
   * FUNCTION MAPPING FOR PLUGIN CALLBACKS
   *********************************************/

    // ProductAttribute
  _this.getProductAttributeValuesForProductAttributeId = getProductAttributeValuesForProductAttributeId;
  _this.hideVisibleProductAttributeValuesLists = hideVisibleProductAttributeValuesLists;
  _this.productAttributeValueListIsHidden = productAttributeValueListIsHidden;
  _this.updateSelectedProductAttributeValue = updateSelectedProductAttributeValue;

  // ProductOptions
  _this.getProductOptionValuesForProductOptionId = getProductOptionValuesForProductOptionId;
  _this.hideVisibleProductOptionValuesLists = hideVisibleProductOptionValuesLists;
  _this.productOptionValueListIsHidden = productOptionValueListIsHidden;
  _this.updateSelectedProductOptionValue = updateSelectedProductOptionValue;

  // ProductInputs
  _this.updateProductInputFieldValue = updateProductInputFieldValue;

  _this.updateCartProductQuantity = updateCartProductQuantity;
  _this.addProductToCart = addProductToCart;

  _this.updateProductPriceInfo = updateProductPriceInfo;
  _this.updateProductStockQuantity = updateProductStockQuantity;

  _this.ajax = performAjaxRequest;

  _this.isInitialized = isInitialized;

  // states management
  _this.setState = setState;
  _this.setStateProductUpdatePending = setStateProductUpdatePending;
  _this.setStateStockUpdatePending = setStateStockUpdatePending;
  _this.setStatePriceUpdatePending = setStatePriceUpdatePending;
  _this.setStateCartButtonLocked = setStateCartButtonLocked;
  _this.setStateCartButtonBusy = setStateCartButtonBusy;
  _this.getStates = getStates;
  _this.getState = getState;
  _this.getGUID = getGUID;
  this.getGUID = getGUID;

  // debugging
  _this.timedDebugGroupStart = timedDebugGroupStart;
  _this.timedDebugGroupStop = timedDebugGroupStop;

  function timedDebugGroupStart(groupName, notCollapsed) {
    if (notCollapsed) {
      debugConsole.group(groupName);
    } else {
      debugConsole.groupCollapsed(groupName);
    }

    debugConsole.time(groupName);
  }

  function timedDebugGroupStop(groupName) {
    debugConsole.timeEnd(groupName);
    debugConsole.groupEnd(groupName);
  }

  _this.compareProductFields = compareProductFields;

  function compareProductFields(childProduct) {
    if (!isProduct(childProduct) || !isChildProduct(childProduct)) {
      return false;
    }

    for (var parentProductFieldName in products.parent.product) {
      if (typeof childProduct.product[parentProductFieldName] == 'undefined') {
        console.warn("Missing field %s in child product", parentProductFieldName);
      }
    }
  }

  /*!
   * contentloaded.js
   *
   * Author: Diego Perini (diego.perini at gmail.com)
   * Summary: cross-browser wrapper for DOMContentLoaded
   * Updated: 20101020
   * License: MIT
   * Version: 1.2
   *
   * URL:
   * http://javascript.nwbox.com/ContentLoaded/
   * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
   */
  function contentLoaded(win, fn) {
    var done = false,
      top = true,

      doc = win.document,
      root = doc.documentElement,

      add = doc.addEventListener ? 'addEventListener' : 'attachEvent',
      rem = doc.addEventListener ? 'removeEventListener' : 'detachEvent',
      pre = doc.addEventListener ? '' : 'on',

      init = function (e) {
        if (e.type == 'readystatechange' && doc.readyState != 'complete') return;
        (e.type == 'load' ? win : doc)[rem](pre + e.type, init, false);
        if (!done && (done = true)) fn.call(win, e.type || e);
      },

      poll = function () {
        try {
          root.doScroll('left');
        } catch (e) {
          setTimeout(poll, 50);
          return;
        }
        init('poll');
      };

    if (doc.readyState == 'complete') fn.call(win, 'lazy');
    else {
      if (doc.createEventObject && root.doScroll) {
        try {
          top = !win.frameElement;
        } catch (e) {}
        if (top) poll();
      }
      doc[add](pre + 'DOMContentLoaded', init, false);
      doc[add](pre + 'readystatechange', init, false);
      win[add](pre + 'load', init, false);
    }
  }

  /**
   * ensure that some functions that are used in this code are present
   */

  function naturalSort(a, b) {
    var re = /(^-?[0-9]+(\.?[0-9]*)[df]?e?[0-9]?$|^0x[0-9a-f]+$|[0-9]+)/gi,
      sre = /(^[ ]*|[ ]*$)/g,
      dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,
      hre = /^0x[0-9a-f]+$/i,
      ore = /^0/,
    // convert all to strings and trim()
      x = a.toString().replace(sre, '') || '',
      y = b.toString().replace(sre, '') || '',
    // chunk/tokenize
      xN = x.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'),
      yN = y.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'),
    // numeric, hex or date detection
      xD = parseInt(x.match(hre)) || (xN.length != 1 && x.match(dre) && Date.parse(x)),
      yD = parseInt(y.match(hre)) || xD && y.match(dre) && Date.parse(y) || null;
    // first try and sort Hex codes or Dates
    if (yD)
      if (xD < yD) return -1;
      else if (xD > yD) return 1;
    // natural sorting through split numeric strings and default strings
    for (var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++) {
      // find floats not starting with '0', string or 0 if not defined (Clint Priest)
      var oFxNcL = !(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0,
        oFyNcL = !(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
      // handle numeric vs string comparison - number < string - (Kyle Adams)
      if (isNaN(oFxNcL) !== isNaN(oFyNcL)) return (isNaN(oFxNcL)) ? 1 : -1;
      // rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
      else if (typeof oFxNcL !== typeof oFyNcL) {
        oFxNcL += '';
        oFyNcL += '';
      }
      if (oFxNcL < oFyNcL) return -1;
      if (oFxNcL > oFyNcL) return 1;
    }
    return 0;
  }
};

window.productDetailsScriptActive = true;

if (!window.productDetailsScriptActive) {
  // override the core if it shouldn't be active
  SGProductDetailsCore = function () {
    this.registerPlugin = function () {};
    this.init = function () {};
  };
}

window.ShopgateProductDetailsCore = new SGProductDetailsCore(typeof activeComponents !== 'undefined' ? activeComponents : null);

(function ($) {
  $.shopgateProductDetails = function (options, products) {
    $.sgHelpers = $.sgHelpers || {};
    window.ShopgateProductDetailsCore.init(options, products);
  };
})(jQuery);



// WEBPACK FOOTER //
// ./Library/1.0/common/product_details/jquery.shopgate-product-details.js